/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelServiceIncidentList.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/service-incident-list";

export class AutogenModelServiceIncidentList<RowType extends ModelRow> extends Endpoint<RowType, RowServiceIncidentListFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowServiceIncidentList extends ModelRow<RowServiceIncidentListFields> {
	constructor(values?: Partial<RowServiceIncidentListFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowServiceIncidentListFields {
	actual_arrival: Date;
	actual_departure: Date;
	appt_required: string;
	caused_by_type: string;
	"caused_by_users.acct_lock_date": Date;
	"caused_by_users.active_date": Date;
	"caused_by_users.admin_user": string;
	"caused_by_users.agent": string;
	"caused_by_users.agree_fieldmarshal": Date;
	"caused_by_users.agree_tailor": Date;
	"caused_by_users.agree_tailor_ext": Date;
	"caused_by_users.all_contacts": string;
	"caused_by_users.allow_new_devices": string;
	"caused_by_users.alternative_user": string;
	"caused_by_users.ap_division_id": string;
	"caused_by_users.appt_sched_id": string;
	"caused_by_users.auth_subject": string;
	"caused_by_users.auto_edit_type": string;
	"caused_by_users.avail_tract_path": string;
	"caused_by_users.avail_tract_sample": string;
	"caused_by_users.available": string;
	"caused_by_users.bridge_customer_access": string;
	"caused_by_users.brokerage_divider": number;
	"caused_by_users.brokerage_planning": string;
	"caused_by_users.brokerage_planning2": string;
	"caused_by_users.brokerage_planning3": string;
	"caused_by_users.brokerage_planning4": string;
	"caused_by_users.brokerage_planning_contnr": string;
	"caused_by_users.call_list_profile": string;
	"caused_by_users.carrier_call_list_id": string;
	"caused_by_users.carrier_mgr_profil": string;
	"caused_by_users.carrier_mgr_profil2": string;
	"caused_by_users.carrier_mgr_profil3": string;
	"caused_by_users.carrier_mgr_profil4": string;
	"caused_by_users.cell_phone": string;
	"caused_by_users.close_window": string;
	"caused_by_users.commission_payee_id": string;
	"caused_by_users.company_id": string;
	"caused_by_users.company_name": string;
	"caused_by_users.conf_cntr_template": number;
	"caused_by_users.conf_template": number;
	"caused_by_users.confirm_record": string;
	"caused_by_users.contact_id": string;
	"caused_by_users.continuous_radius": number;
	"caused_by_users.crm_vs_profile": string;
	"caused_by_users.csm_profile_id": string;
	"caused_by_users.csm_profile_id2": string;
	"caused_by_users.csm_profile_id3": string;
	"caused_by_users.csm_profile_id4": string;
	"caused_by_users.currency_reporting": string;
	"caused_by_users.currency_transaction": string;
	"caused_by_users.daily_advance_limits": string;
	"caused_by_users.daily_brok_profile": string;
	"caused_by_users.daily_snap_profile": string;
	"caused_by_users.date_format": string;
	"caused_by_users.default_search": number;
	"caused_by_users.default_wirecode": string;
	"caused_by_users.delivered_load_day": number;
	"caused_by_users.department_id": string;
	"caused_by_users.detention_profile_id": string;
	"caused_by_users.detention_profile_id2": string;
	"caused_by_users.detention_profile_id3": string;
	"caused_by_users.detention_profile_id4": string;
	"caused_by_users.disp_new_order_screen": string;
	"caused_by_users.distance_calc_vendor": string;
	"caused_by_users.dock_enable_wfmd_mode_swtch": string;
	"caused_by_users.dock_login_id": string;
	"caused_by_users.dragndrop_profile_id": string;
	"caused_by_users.driver_manager_profile": string;
	"caused_by_users.driver_manager_profile2": string;
	"caused_by_users.driver_manager_profile3": string;
	"caused_by_users.driver_manager_profile4": string;
	"caused_by_users.driver_manager_vendor": string;
	"caused_by_users.driver_managers": string;
	"caused_by_users.drivers_wo_manager": string;
	"caused_by_users.ds_cap_profile": string;
	"caused_by_users.ds_mv_eta_profile": string;
	"caused_by_users.ds_mv_eval_profile": string;
	"caused_by_users.dsp_override_user": string;
	"caused_by_users.email_address": string;
	"caused_by_users.email_bcc": string;
	"caused_by_users.email_client": string;
	"caused_by_users.email_host": string;
	"caused_by_users.email_imap_host": string;
	"caused_by_users.email_imap_password": string;
	"caused_by_users.email_imap_sent_folder": string;
	"caused_by_users.email_imap_ssl": string;
	"caused_by_users.email_imap_username": string;
	"caused_by_users.email_override_company": string;
	"caused_by_users.email_password": string;
	"caused_by_users.email_port": number;
	"caused_by_users.email_protocol": string;
	"caused_by_users.email_use_sent_folder": string;
	"caused_by_users.email_username": string;
	"caused_by_users.employee_type": string;
	"caused_by_users.enable_alerts": string;
	"caused_by_users.extension": string;
	"caused_by_users.external_password": string;
	"caused_by_users.external_user_id": string;
	"caused_by_users.failed_logins": number;
	"caused_by_users.fax": string;
	"caused_by_users.fileimport_profile": string;
	"caused_by_users.findnear_vendor": string;
	"caused_by_users.fleetmgmt_prof_id": string;
	"caused_by_users.fm_account_id": string;
	"caused_by_users.fm_can_view_metadata": string;
	"caused_by_users.fm_profile_id": string;
	"caused_by_users.fm_webhook_url": string;
	"caused_by_users.ftl_revenue_code_id": string;
	"caused_by_users.google_map_layer": string;
	"caused_by_users.google_map_type": string;
	"caused_by_users.grid_even_row_color": number;
	"caused_by_users.grid_insert_sort": string;
	"caused_by_users.grid_odd_row_color": number;
	"caused_by_users.id": string;
	"caused_by_users.img_category": string;
	"caused_by_users.inactive_date": Date;
	"caused_by_users.is_active": string;
	"caused_by_users.is_clearer": string;
	"caused_by_users.is_closer": string;
	"caused_by_users.is_dock_supervisor": string;
	"caused_by_users.is_dock_worker": string;
	"caused_by_users.is_email_confirmed": string;
	"caused_by_users.is_mcleod": string;
	"caused_by_users.issue_atm_cash": string;
	"caused_by_users.lock_status": string;
	"caused_by_users.log_sql": string;
	"caused_by_users.login_id": string;
	"caused_by_users.ltl_carrier_brk_status": string;
	"caused_by_users.ltl_mapping_vendor": string;
	"caused_by_users.ltl_quote_template": number;
	"caused_by_users.manifest_profile": string;
	"caused_by_users.margin_percentage": number;
	"caused_by_users.max_payment_code_amt": number;
	"caused_by_users.max_payment_code_amt_c": string;
	"caused_by_users.max_payment_code_amt_d": Date;
	"caused_by_users.max_payment_code_amt_n": number;
	"caused_by_users.max_payment_code_amt_r": number;
	"caused_by_users.mc_position_vendor": string;
	"caused_by_users.menu_tree_view": string;
	"caused_by_users.mfa_device_id": string;
	"caused_by_users.mfa_last_prompted": Date;
	"caused_by_users.mfa_secret": string;
	"caused_by_users.mfa_status": string;
	"caused_by_users.mobcomm_profile_id": string;
	"caused_by_users.mobile_pw_reset_token": string;
	"caused_by_users.mobile_pw_token_expire_ms": number;
	"caused_by_users.move_dates": string;
	"caused_by_users.movement_map_vendor": string;
	"caused_by_users.name": string;
	"caused_by_users.notification": string;
	"caused_by_users.notify_alerts": string;
	"caused_by_users.notify_frequency": string;
	"caused_by_users.notify_method": string;
	"caused_by_users.notify_occurance": string;
	"caused_by_users.operations_user_id": string;
	"caused_by_users.order_mode": string;
	"caused_by_users.order_planning2": string;
	"caused_by_users.order_planning3": string;
	"caused_by_users.order_planning4": string;
	"caused_by_users.order_planning_vendor": string;
	"caused_by_users.order_tran_request": string;
	"caused_by_users.orderhist_profile": string;
	"caused_by_users.outbound_notification": string;
	"caused_by_users.override_vendor_division": string;
	"caused_by_users.payee_id": string;
	"caused_by_users.pbw_brokerage_planning": string;
	"caused_by_users.phone": string;
	"caused_by_users.planner": string;
	"caused_by_users.planning": string;
	"caused_by_users.planning_container": string;
	"caused_by_users.planning_divider": number;
	"caused_by_users.portal_admin_id": string;
	"caused_by_users.primary_agency": string;
	"caused_by_users.prompt_cont_moves": string;
	"caused_by_users.quote_comp_act_create": string;
	"caused_by_users.quote_comp_act_id": string;
	"caused_by_users.quote_pend_act_create": string;
	"caused_by_users.quote_pend_act_id": string;
	"caused_by_users.quote_template": number;
	"caused_by_users.rapid_alert_expand": string;
	"caused_by_users.rapid_alert_sound": string;
	"caused_by_users.receive_alerts": string;
	"caused_by_users.recruiting_profile": string;
	"caused_by_users.request_location_vendor": string;
	"caused_by_users.revenue_code_id": string;
	"caused_by_users.route_detail_vendor": string;
	"caused_by_users.save_screen_sizes": string;
	"caused_by_users.search_history_limit": number;
	"caused_by_users.sec_ans1": string;
	"caused_by_users.sec_ans2": string;
	"caused_by_users.sec_question1": number;
	"caused_by_users.sec_question2": number;
	"caused_by_users.seg_alloc_code": string;
	"caused_by_users.sel_text_on_focus": string;
	"caused_by_users.show_active": string;
	"caused_by_users.show_google_route": string;
	"caused_by_users.show_inactive": string;
	"caused_by_users.single_point_vendor": string;
	"caused_by_users.support_inactivate_date": Date;
	"caused_by_users.system_tray": string;
	"caused_by_users.table_even_row_color": string;
	"caused_by_users.table_odd_row_color": string;
	"caused_by_users.telephony_access_token": string;
	"caused_by_users.telephony_access_token_exp": Date;
	"caused_by_users.telephony_number": string;
	"caused_by_users.telephony_password": string;
	"caused_by_users.telephony_refresh_token": string;
	"caused_by_users.telephony_refresh_token_exp": Date;
	"caused_by_users.terminal_id": string;
	"caused_by_users.time_format": string;
	"caused_by_users.token_key": number;
	"caused_by_users.toolbar_multi_rows": string;
	"caused_by_users.toolbar_setting": string;
	"caused_by_users.trailer_loan_profile_id": string;
	"caused_by_users.trailer_wash_loc": string;
	"caused_by_users.trailer_wash_user": string;
	"caused_by_users.trimble_map_traffic": string;
	"caused_by_users.tw_seg_code": string;
	"caused_by_users.tw_ticket_template": number;
	"caused_by_users.type_agents": string;
	"caused_by_users.type_carrier": string;
	"caused_by_users.type_company_drs": string;
	"caused_by_users.type_number": string;
	"caused_by_users.type_owner_oper": string;
	"caused_by_users.user_group": string;
	"caused_by_users.vendor_user_id": string;
	"caused_by_users.view_movement_vendor": string;
	"caused_by_users.waterfall_default_rt_guide": string;
	"caused_by_users.waterfall_include_rates": string;
	"caused_by_users.waterfall_include_rt_guides": string;
	"caused_by_users.waterfall_prevent_tendering": string;
	"caused_by_users.web_acct_status": string;
	"caused_by_users.web_agent": string;
	"caused_by_users.web_created_on": Date;
	"caused_by_users.web_enabled_on": Date;
	"caused_by_users.web_last_login": Date;
	"caused_by_users.web_locked_on": Date;
	"caused_by_users.web_map": string;
	"caused_by_users.web_password": string;
	"caused_by_users.web_user_id": string;
	"caused_by_users.web_user_type": string;
	"caused_by_users.window_location": string;
	"caused_by_users.windows_login": string;
	"caused_by_users.wire_trans_per_day": number;
	"caused_by_users.zone_mapping_vendor": string;
	company_id: string;
	"customer.activity_count": number;
	"customer.activity_start_date": Date;
	"customer.add_empty_distance_occ": string;
	"customer.add_finance_charge": string;
	"customer.address1": string;
	"customer.address2": string;
	"customer.allow_inc_in_frt": string;
	"customer.auto_rate": string;
	"customer.available_template": number;
	"customer.average_bill": number;
	"customer.average_bill_c": string;
	"customer.average_bill_d": Date;
	"customer.average_bill_n": number;
	"customer.average_bill_r": number;
	"customer.average_pay_days": number;
	"customer.balance": number;
	"customer.balance_c": string;
	"customer.balance_d": Date;
	"customer.balance_n": number;
	"customer.balance_r": number;
	"customer.benchmark_ctg_uid": number;
	"customer.benchmark_tar_uid": number;
	"customer.bill_due_days": number;
	"customer.bill_format_flag": string;
	"customer.bill_template": number;
	"customer.bill_transfer_when": string;
	"customer.billed_loads": number;
	"customer.bl_logo": string;
	"customer.bl_logo_name": string;
	"customer.blanket_buy_tariff_id": string;
	"customer.blanket_sell_tariff_id": string;
	"customer.bridge_id": string;
	"customer.brokerage_filter": string;
	"customer.business_hours": string;
	"customer.business_number": string;
	"customer.buy_tariff_id": string;
	"customer.category": string;
	"customer.cert_of_ins_date": Date;
	"customer.charge_detention": string;
	"customer.chassis_chargeby": string;
	"customer.chassis_freedays": number;
	"customer.chassis_rate": number;
	"customer.chassis_rate_c": string;
	"customer.chassis_rate_d": Date;
	"customer.chassis_rate_n": number;
	"customer.chassis_rate_r": number;
	"customer.city": string;
	"customer.city_id": number;
	"customer.coll_thresh_pd1": number;
	"customer.coll_thresh_pd1_c": string;
	"customer.coll_thresh_pd1_d": Date;
	"customer.coll_thresh_pd1_n": number;
	"customer.coll_thresh_pd1_r": number;
	"customer.coll_thresh_pd2": number;
	"customer.coll_thresh_pd2_c": string;
	"customer.coll_thresh_pd2_d": Date;
	"customer.coll_thresh_pd2_n": number;
	"customer.coll_thresh_pd2_r": number;
	"customer.coll_thresh_pd3": number;
	"customer.coll_thresh_pd3_c": string;
	"customer.coll_thresh_pd3_d": Date;
	"customer.coll_thresh_pd3_n": number;
	"customer.coll_thresh_pd3_r": number;
	"customer.coll_thresh_pd4": number;
	"customer.coll_thresh_pd4_c": string;
	"customer.coll_thresh_pd4_d": Date;
	"customer.coll_thresh_pd4_n": number;
	"customer.coll_thresh_pd4_r": number;
	"customer.collections_id": string;
	"customer.collections_ok": string;
	"customer.company_id": string;
	"customer.confidence_level": number;
	"customer.container_chargeby": string;
	"customer.container_freedays": number;
	"customer.container_rate": number;
	"customer.container_rate_c": string;
	"customer.container_rate_d": Date;
	"customer.container_rate_n": number;
	"customer.container_rate_r": number;
	"customer.contract_cbc": string;
	"customer.contract_ccc": string;
	"customer.contract_gbc": string;
	"customer.contract_gcc": string;
	"customer.contract_sbc": string;
	"customer.contract_scc": string;
	"customer.controlling_carrier_code": string;
	"customer.conversion_date": Date;
	"customer.cost_ctg_uid": number;
	"customer.cost_tar_uid": number;
	"customer.covered_template": number;
	"customer.cp_logo": string;
	"customer.cp_logo_name": string;
	"customer.credit_application": string;
	"customer.credit_check_date": Date;
	"customer.credit_limit": number;
	"customer.credit_limit_c": string;
	"customer.credit_limit_d": Date;
	"customer.credit_limit_n": number;
	"customer.credit_limit_r": number;
	"customer.credit_status": string;
	"customer.credit_warning_pct": number;
	"customer.ctg_uid": number;
	"customer.currency_type": string;
	"customer.cust_requestor_load_id": string;
	"customer.cust_stmt_template": number;
	"customer.d_and_b_code": string;
	"customer.d_and_b_date": Date;
	"customer.d_and_b_number": string;
	"customer.days_between_calls": number;
	"customer.deadhead_target": number;
	"customer.ded_last_fixed_cost_billdt": Date;
	"customer.dedicated_cycle": string;
	"customer.dedicated_revenue_code_id": string;
	"customer.dedicated_seg_alloc_code": string;
	"customer.dedicated_start_day": string;
	"customer.dedicated_template": number;
	"customer.def_rate_confirm_temp": number;
	"customer.delivered_template": number;
	"customer.departure_date_at": string;
	"customer.disable_automatic_tracking": string;
	"customer.display_eta": string;
	"customer.display_ysplit_stops": string;
	"customer.distance_method": string;
	"customer.distance_profile": string;
	"customer.distance_source": string;
	"customer.distance_type": string;
	"customer.dot_number": string;
	"customer.driver_load": string;
	"customer.empty_distance_charge_id": string;
	"customer.empty_distance_rate": number;
	"customer.enable_notifications": string;
	"customer.enforce_dep_dates": string;
	"customer.entered_date": Date;
	"customer.excise_taxable": string;
	"customer.expected_close": Date;
	"customer.extend_rates": string;
	"customer.factor_percent": number;
	"customer.factor_receivables": string;
	"customer.factoring_id": string;
	"customer.fak_profile_id": string;
	"customer.fourkites_customer_id": string;
	"customer.fuel_amount": number;
	"customer.fuel_base_price": number;
	"customer.fuel_credit": string;
	"customer.fuel_method": string;
	"customer.fuel_percent": number;
	"customer.fuel_price_region": string;
	"customer.fuel_surcharge_id": string;
	"customer.fuel_surchg_enddt": Date;
	"customer.fuel_surchg_strtdt": Date;
	"customer.fuel_variance": number;
	"customer.global_detention": string;
	"customer.google_place_id": string;
	"customer.gp_exclude": string;
	"customer.gp_exported": Date;
	"customer.grace_period": number;
	"customer.high_balance": number;
	"customer.high_balance_c": string;
	"customer.high_balance_d": Date;
	"customer.high_balance_n": number;
	"customer.high_balance_r": number;
	"customer.ic_company_id": string;
	"customer.id": string;
	"customer.include_by_date": string;
	"customer.include_empty_distance": string;
	"customer.include_fuel_surcharge": string;
	"customer.include_split_point": string;
	"customer.is_active": string;
	"customer.is_consignee": string;
	"customer.is_distribution_center": string;
	"customer.is_drop_yard": string;
	"customer.is_geocoded": string;
	"customer.is_intercompany": string;
	"customer.is_pallets_required": string;
	"customer.is_shipper": string;
	"customer.is_trailer_pool_required": string;
	"customer.jaguar_id": number;
	"customer.last_bill_date": Date;
	"customer.last_fin_charge_dt": Date;
	"customer.last_pay_date": Date;
	"customer.last_ship_date": Date;
	"customer.latitude": number;
	"customer.location_id": string;
	"customer.longitude": number;
	"customer.macropoint_requestor_id": string;
	"customer.main_phone": string;
	"customer.manual_exchange": string;
	"customer.mark_plan_id": string;
	"customer.max_pay_percent": number;
	"customer.misc_bill_template": number;
	"customer.monthly_order_goal": number;
	"customer.motor_carrier_id": string;
	"customer.name": string;
	"customer.next_call_date": Date;
	"customer.next_rec_call": Date;
	"customer.nxt_action_code_id": string;
	"customer.nxt_action_date": Date;
	"customer.operations_user": string;
	"customer.order_count": number;
	"customer.order_detail_at": string;
	"customer.order_start_date": Date;
	"customer.p44_profile_id": string;
	"customer.paid_loads": number;
	"customer.pay_days_date": Date;
	"customer.pay_days_orders": number;
	"customer.payee_id": string;
	"customer.pd0_alert": number;
	"customer.pd1_np_auto": string;
	"customer.pd1_sp_auto": string;
	"customer.pd1_sp_thresh": number;
	"customer.pd1_sp_thresh_c": string;
	"customer.pd1_sp_thresh_d": Date;
	"customer.pd1_sp_thresh_n": number;
	"customer.pd1_sp_thresh_r": number;
	"customer.pd2_np_auto": string;
	"customer.pd2_sp_auto": string;
	"customer.pd2_sp_thresh": number;
	"customer.pd2_sp_thresh_c": string;
	"customer.pd2_sp_thresh_d": Date;
	"customer.pd2_sp_thresh_n": number;
	"customer.pd2_sp_thresh_r": number;
	"customer.pd3_np_auto": string;
	"customer.pd3_sp_auto": string;
	"customer.pd3_sp_thresh": number;
	"customer.pd3_sp_thresh_c": string;
	"customer.pd3_sp_thresh_d": Date;
	"customer.pd3_sp_thresh_n": number;
	"customer.pd3_sp_thresh_r": number;
	"customer.pd4_np_auto": string;
	"customer.pd4_sp_auto": string;
	"customer.pd4_sp_thresh": number;
	"customer.pd4_sp_thresh_c": string;
	"customer.pd4_sp_thresh_d": Date;
	"customer.pd4_sp_thresh_n": number;
	"customer.pd4_sp_thresh_r": number;
	"customer.plc_uid": number;
	"customer.post_summary_dtl": string;
	"customer.potential": number;
	"customer.potential_c": string;
	"customer.potential_d": Date;
	"customer.potential_n": number;
	"customer.potential_r": number;
	"customer.prev_code": string;
	"customer.primary_agency": string;
	"customer.primary_commodity_id": string;
	"customer.primary_contact": string;
	"customer.primary_sort": string;
	"customer.primary_trailer_type": string;
	"customer.print_containers": string;
	"customer.progress_template": number;
	"customer.prospect_type_id": string;
	"customer.quebec_number": string;
	"customer.quote_days_to_expire": number;
	"customer.rate_override_nmfc_code": string;
	"customer.reassign_profile_id": string;
	"customer.rec_call_days": number;
	"customer.remarks": string;
	"customer.require_tracking": string;
	"customer.required_vendor": string;
	"customer.revenue": number;
	"customer.revenue_c": string;
	"customer.revenue_d": Date;
	"customer.revenue_n": number;
	"customer.revenue_r": number;
	"customer.revenue_start_date": Date;
	"customer.routing_guide_profile_id": string;
	"customer.sales_manager_id": string;
	"customer.sales_status_id": string;
	"customer.salesperson_id": string;
	"customer.search_city": string;
	"customer.search_state_id": string;
	"customer.search_zip_code": string;
	"customer.secondary_sort": string;
	"customer.sell_tariff_id": string;
	"customer.service_fail_cons": string;
	"customer.service_fail_drop": string;
	"customer.service_fail_pick": string;
	"customer.service_fail_ship": string;
	"customer.service_failures": string;
	"customer.service_failures_review": string;
	"customer.shipment_ident_type": string;
	"customer.sic_code": string;
	"customer.smc3_profile_id": string;
	"customer.start_date": Date;
	"customer.state_id": string;
	"customer.summary_billing": string;
	"customer.summary_template": number;
	"customer.tar_uid": number;
	"customer.target_profit": number;
	"customer.tenfour_customer_id": string;
	"customer.tracking_hours_prior": number;
	"customer.trimble_place_id": string;
	"customer.type_of": string;
	"customer.use_local_mile": string;
	"customer.vm_part_update": string;
	"customer.waterfall_auto_route_guides": string;
	"customer.waterfall_lead_time": number;
	"customer.waterfall_notify_email": string;
	"customer.waterfall_process": string;
	"customer.website_url": string;
	"customer.wf_auto_renbill": string;
	"customer.wf_autobill": string;
	"customer.wf_bwop": string;
	"customer.wf_queue": number;
	"customer.zip_code": string;
	"customer.zone_id": string;
	customer_id: string;
	dispatcher_user_id: string;
	"dispatcher_users.acct_lock_date": Date;
	"dispatcher_users.active_date": Date;
	"dispatcher_users.admin_user": string;
	"dispatcher_users.agent": string;
	"dispatcher_users.agree_fieldmarshal": Date;
	"dispatcher_users.agree_tailor": Date;
	"dispatcher_users.agree_tailor_ext": Date;
	"dispatcher_users.all_contacts": string;
	"dispatcher_users.allow_new_devices": string;
	"dispatcher_users.alternative_user": string;
	"dispatcher_users.ap_division_id": string;
	"dispatcher_users.appt_sched_id": string;
	"dispatcher_users.auth_subject": string;
	"dispatcher_users.auto_edit_type": string;
	"dispatcher_users.avail_tract_path": string;
	"dispatcher_users.avail_tract_sample": string;
	"dispatcher_users.available": string;
	"dispatcher_users.bridge_customer_access": string;
	"dispatcher_users.brokerage_divider": number;
	"dispatcher_users.brokerage_planning": string;
	"dispatcher_users.brokerage_planning2": string;
	"dispatcher_users.brokerage_planning3": string;
	"dispatcher_users.brokerage_planning4": string;
	"dispatcher_users.brokerage_planning_contnr": string;
	"dispatcher_users.call_list_profile": string;
	"dispatcher_users.carrier_call_list_id": string;
	"dispatcher_users.carrier_mgr_profil": string;
	"dispatcher_users.carrier_mgr_profil2": string;
	"dispatcher_users.carrier_mgr_profil3": string;
	"dispatcher_users.carrier_mgr_profil4": string;
	"dispatcher_users.cell_phone": string;
	"dispatcher_users.close_window": string;
	"dispatcher_users.commission_payee_id": string;
	"dispatcher_users.company_id": string;
	"dispatcher_users.company_name": string;
	"dispatcher_users.conf_cntr_template": number;
	"dispatcher_users.conf_template": number;
	"dispatcher_users.confirm_record": string;
	"dispatcher_users.contact_id": string;
	"dispatcher_users.continuous_radius": number;
	"dispatcher_users.crm_vs_profile": string;
	"dispatcher_users.csm_profile_id": string;
	"dispatcher_users.csm_profile_id2": string;
	"dispatcher_users.csm_profile_id3": string;
	"dispatcher_users.csm_profile_id4": string;
	"dispatcher_users.currency_reporting": string;
	"dispatcher_users.currency_transaction": string;
	"dispatcher_users.daily_advance_limits": string;
	"dispatcher_users.daily_brok_profile": string;
	"dispatcher_users.daily_snap_profile": string;
	"dispatcher_users.date_format": string;
	"dispatcher_users.default_search": number;
	"dispatcher_users.default_wirecode": string;
	"dispatcher_users.delivered_load_day": number;
	"dispatcher_users.department_id": string;
	"dispatcher_users.detention_profile_id": string;
	"dispatcher_users.detention_profile_id2": string;
	"dispatcher_users.detention_profile_id3": string;
	"dispatcher_users.detention_profile_id4": string;
	"dispatcher_users.disp_new_order_screen": string;
	"dispatcher_users.distance_calc_vendor": string;
	"dispatcher_users.dock_enable_wfmd_mode_swtch": string;
	"dispatcher_users.dock_login_id": string;
	"dispatcher_users.dragndrop_profile_id": string;
	"dispatcher_users.driver_manager_profile": string;
	"dispatcher_users.driver_manager_profile2": string;
	"dispatcher_users.driver_manager_profile3": string;
	"dispatcher_users.driver_manager_profile4": string;
	"dispatcher_users.driver_manager_vendor": string;
	"dispatcher_users.driver_managers": string;
	"dispatcher_users.drivers_wo_manager": string;
	"dispatcher_users.ds_cap_profile": string;
	"dispatcher_users.ds_mv_eta_profile": string;
	"dispatcher_users.ds_mv_eval_profile": string;
	"dispatcher_users.dsp_override_user": string;
	"dispatcher_users.email_address": string;
	"dispatcher_users.email_bcc": string;
	"dispatcher_users.email_client": string;
	"dispatcher_users.email_host": string;
	"dispatcher_users.email_imap_host": string;
	"dispatcher_users.email_imap_password": string;
	"dispatcher_users.email_imap_sent_folder": string;
	"dispatcher_users.email_imap_ssl": string;
	"dispatcher_users.email_imap_username": string;
	"dispatcher_users.email_override_company": string;
	"dispatcher_users.email_password": string;
	"dispatcher_users.email_port": number;
	"dispatcher_users.email_protocol": string;
	"dispatcher_users.email_use_sent_folder": string;
	"dispatcher_users.email_username": string;
	"dispatcher_users.employee_type": string;
	"dispatcher_users.enable_alerts": string;
	"dispatcher_users.extension": string;
	"dispatcher_users.external_password": string;
	"dispatcher_users.external_user_id": string;
	"dispatcher_users.failed_logins": number;
	"dispatcher_users.fax": string;
	"dispatcher_users.fileimport_profile": string;
	"dispatcher_users.findnear_vendor": string;
	"dispatcher_users.fleetmgmt_prof_id": string;
	"dispatcher_users.fm_account_id": string;
	"dispatcher_users.fm_can_view_metadata": string;
	"dispatcher_users.fm_profile_id": string;
	"dispatcher_users.fm_webhook_url": string;
	"dispatcher_users.ftl_revenue_code_id": string;
	"dispatcher_users.google_map_layer": string;
	"dispatcher_users.google_map_type": string;
	"dispatcher_users.grid_even_row_color": number;
	"dispatcher_users.grid_insert_sort": string;
	"dispatcher_users.grid_odd_row_color": number;
	"dispatcher_users.id": string;
	"dispatcher_users.img_category": string;
	"dispatcher_users.inactive_date": Date;
	"dispatcher_users.is_active": string;
	"dispatcher_users.is_clearer": string;
	"dispatcher_users.is_closer": string;
	"dispatcher_users.is_dock_supervisor": string;
	"dispatcher_users.is_dock_worker": string;
	"dispatcher_users.is_email_confirmed": string;
	"dispatcher_users.is_mcleod": string;
	"dispatcher_users.issue_atm_cash": string;
	"dispatcher_users.lock_status": string;
	"dispatcher_users.log_sql": string;
	"dispatcher_users.login_id": string;
	"dispatcher_users.ltl_carrier_brk_status": string;
	"dispatcher_users.ltl_mapping_vendor": string;
	"dispatcher_users.ltl_quote_template": number;
	"dispatcher_users.manifest_profile": string;
	"dispatcher_users.margin_percentage": number;
	"dispatcher_users.max_payment_code_amt": number;
	"dispatcher_users.max_payment_code_amt_c": string;
	"dispatcher_users.max_payment_code_amt_d": Date;
	"dispatcher_users.max_payment_code_amt_n": number;
	"dispatcher_users.max_payment_code_amt_r": number;
	"dispatcher_users.mc_position_vendor": string;
	"dispatcher_users.menu_tree_view": string;
	"dispatcher_users.mfa_device_id": string;
	"dispatcher_users.mfa_last_prompted": Date;
	"dispatcher_users.mfa_secret": string;
	"dispatcher_users.mfa_status": string;
	"dispatcher_users.mobcomm_profile_id": string;
	"dispatcher_users.mobile_pw_reset_token": string;
	"dispatcher_users.mobile_pw_token_expire_ms": number;
	"dispatcher_users.move_dates": string;
	"dispatcher_users.movement_map_vendor": string;
	"dispatcher_users.name": string;
	"dispatcher_users.notification": string;
	"dispatcher_users.notify_alerts": string;
	"dispatcher_users.notify_frequency": string;
	"dispatcher_users.notify_method": string;
	"dispatcher_users.notify_occurance": string;
	"dispatcher_users.operations_user_id": string;
	"dispatcher_users.order_mode": string;
	"dispatcher_users.order_planning2": string;
	"dispatcher_users.order_planning3": string;
	"dispatcher_users.order_planning4": string;
	"dispatcher_users.order_planning_vendor": string;
	"dispatcher_users.order_tran_request": string;
	"dispatcher_users.orderhist_profile": string;
	"dispatcher_users.outbound_notification": string;
	"dispatcher_users.override_vendor_division": string;
	"dispatcher_users.payee_id": string;
	"dispatcher_users.pbw_brokerage_planning": string;
	"dispatcher_users.phone": string;
	"dispatcher_users.planner": string;
	"dispatcher_users.planning": string;
	"dispatcher_users.planning_container": string;
	"dispatcher_users.planning_divider": number;
	"dispatcher_users.portal_admin_id": string;
	"dispatcher_users.primary_agency": string;
	"dispatcher_users.prompt_cont_moves": string;
	"dispatcher_users.quote_comp_act_create": string;
	"dispatcher_users.quote_comp_act_id": string;
	"dispatcher_users.quote_pend_act_create": string;
	"dispatcher_users.quote_pend_act_id": string;
	"dispatcher_users.quote_template": number;
	"dispatcher_users.rapid_alert_expand": string;
	"dispatcher_users.rapid_alert_sound": string;
	"dispatcher_users.receive_alerts": string;
	"dispatcher_users.recruiting_profile": string;
	"dispatcher_users.request_location_vendor": string;
	"dispatcher_users.revenue_code_id": string;
	"dispatcher_users.route_detail_vendor": string;
	"dispatcher_users.save_screen_sizes": string;
	"dispatcher_users.search_history_limit": number;
	"dispatcher_users.sec_ans1": string;
	"dispatcher_users.sec_ans2": string;
	"dispatcher_users.sec_question1": number;
	"dispatcher_users.sec_question2": number;
	"dispatcher_users.seg_alloc_code": string;
	"dispatcher_users.sel_text_on_focus": string;
	"dispatcher_users.show_active": string;
	"dispatcher_users.show_google_route": string;
	"dispatcher_users.show_inactive": string;
	"dispatcher_users.single_point_vendor": string;
	"dispatcher_users.support_inactivate_date": Date;
	"dispatcher_users.system_tray": string;
	"dispatcher_users.table_even_row_color": string;
	"dispatcher_users.table_odd_row_color": string;
	"dispatcher_users.telephony_access_token": string;
	"dispatcher_users.telephony_access_token_exp": Date;
	"dispatcher_users.telephony_number": string;
	"dispatcher_users.telephony_password": string;
	"dispatcher_users.telephony_refresh_token": string;
	"dispatcher_users.telephony_refresh_token_exp": Date;
	"dispatcher_users.terminal_id": string;
	"dispatcher_users.time_format": string;
	"dispatcher_users.token_key": number;
	"dispatcher_users.toolbar_multi_rows": string;
	"dispatcher_users.toolbar_setting": string;
	"dispatcher_users.trailer_loan_profile_id": string;
	"dispatcher_users.trailer_wash_loc": string;
	"dispatcher_users.trailer_wash_user": string;
	"dispatcher_users.trimble_map_traffic": string;
	"dispatcher_users.tw_seg_code": string;
	"dispatcher_users.tw_ticket_template": number;
	"dispatcher_users.type_agents": string;
	"dispatcher_users.type_carrier": string;
	"dispatcher_users.type_company_drs": string;
	"dispatcher_users.type_number": string;
	"dispatcher_users.type_owner_oper": string;
	"dispatcher_users.user_group": string;
	"dispatcher_users.vendor_user_id": string;
	"dispatcher_users.view_movement_vendor": string;
	"dispatcher_users.waterfall_default_rt_guide": string;
	"dispatcher_users.waterfall_include_rates": string;
	"dispatcher_users.waterfall_include_rt_guides": string;
	"dispatcher_users.waterfall_prevent_tendering": string;
	"dispatcher_users.web_acct_status": string;
	"dispatcher_users.web_agent": string;
	"dispatcher_users.web_created_on": Date;
	"dispatcher_users.web_enabled_on": Date;
	"dispatcher_users.web_last_login": Date;
	"dispatcher_users.web_locked_on": Date;
	"dispatcher_users.web_map": string;
	"dispatcher_users.web_password": string;
	"dispatcher_users.web_user_id": string;
	"dispatcher_users.web_user_type": string;
	"dispatcher_users.window_location": string;
	"dispatcher_users.windows_login": string;
	"dispatcher_users.wire_trans_per_day": number;
	"dispatcher_users.zone_mapping_vendor": string;
	"driver.ace_id": string;
	"driver.address": string;
	"driver.alert": string;
	"driver.allow_trailer_drop": string;
	"driver.avl_as_of_date": Date;
	"driver.avl_drive_hours": number;
	"driver.avl_hours": number;
	"driver.avl_onduty_hours": number;
	"driver.base_term1": string;
	"driver.base_term2": string;
	"driver.base_zip1": string;
	"driver.base_zip2": string;
	"driver.birth_date": Date;
	"driver.bseg": string;
	"driver.can_rehire": string;
	"driver.capcreat_filter": string;
	"driver.cb": string;
	"driver.cell_phone": string;
	"driver.chain_pref_1": string;
	"driver.chain_pref_1_value": number;
	"driver.chain_pref_2": string;
	"driver.chain_pref_2_value": number;
	"driver.choice_allocation": string;
	"driver.choice_commodity": string;
	"driver.choice_commodity_exclude": string;
	"driver.choice_customer": string;
	"driver.choice_equip_type": string;
	"driver.choice_exclude_hazmat": string;
	"driver.choice_order_type": string;
	"driver.choice_priority1": string;
	"driver.choice_priority1_value": number;
	"driver.choice_priority2": string;
	"driver.choice_priority2_value": number;
	"driver.choice_revenue": string;
	"driver.choice_review_dt": Date;
	"driver.citizen": string;
	"driver.citizen_country": string;
	"driver.city": string;
	"driver.city_id": number;
	"driver.cmove": string;
	"driver.company_id": string;
	"driver.country_hos_rules": string;
	"driver.country_id": string;
	"driver.currenteqpgrpid": string;
	"driver.ded_rqmt_type": string;
	"driver.ded_type": string;
	"driver.disable_driver_choice": string;
	"driver.disable_feasibility": string;
	"driver.disable_remote_access": string;
	"driver.doubles_certified": string;
	"driver.dri_uid": number;
	"driver.drvr_class": string;
	"driver.ds_model_flag": string;
	"driver.eld_exempt_reason_id": string;
	"driver.email": string;
	"driver.emrg_response_date": Date;
	"driver.enable_driver_app": string;
	"driver.enable_load_choice": string;
	"driver.end_status_date": Date;
	"driver.enginedata_pwd": string;
	"driver.equipment_type_id": string;
	"driver.event_date": Date;
	"driver.event_status": string;
	"driver.exclude_allocation": string;
	"driver.exclude_commodity": string;
	"driver.exclude_customer": string;
	"driver.exclude_equip_type": string;
	"driver.exclude_feasibility": string;
	"driver.exclude_order_type": string;
	"driver.exclude_revenue": string;
	"driver.experience": string;
	"driver.first_name": string;
	"driver.fleet_manager": string;
	"driver.fmcsa_clearinghouse_date": Date;
	"driver.group_id": string;
	"driver.hazmat_certified": string;
	"driver.hazmat_date": Date;
	"driver.hire_date": Date;
	"driver.hm126c_date": Date;
	"driver.home_duration": number;
	"driver.home_location_id": string;
	"driver.id": string;
	"driver.is_active": string;
	"driver.last_34_hour_start_date": Date;
	"driver.last_break_date": Date;
	"driver.last_home_date": Date;
	"driver.last_review_date": Date;
	"driver.latitude": number;
	"driver.license_country": string;
	"driver.license_date": Date;
	"driver.license_no": string;
	"driver.license_state": string;
	"driver.logbook_required": string;
	"driver.longitude": number;
	"driver.manual_pta_update": string;
	"driver.maryland_perm_date": Date;
	"driver.max_dispatches": number;
	"driver.max_dist_loc1": number;
	"driver.max_dist_loc2": number;
	"driver.max_mi_per_day": number;
	"driver.mc_login": string;
	"driver.mc_unit_password": string;
	"driver.medical_cert_exempt": string;
	"driver.medical_cert_expire": Date;
	"driver.model_flag": string;
	"driver.mpw_driver_contact_method": string;
	"driver.mpw_driver_high": number;
	"driver.mpw_driver_low": number;
	"driver.mpw_exclude": string;
	"driver.mpw_last_contact": Date;
	"driver.mpw_num_attempts": number;
	"driver.mpw_num_orders": number;
	"driver.mvr_date": Date;
	"driver.name": string;
	"driver.name_mid_initial": string;
	"driver.name_of_spouse": string;
	"driver.next_home_date": Date;
	"driver.num_complaints": number;
	"driver.pager": string;
	"driver.passport": string;
	"driver.payee_id": string;
	"driver.personal_conveyance": string;
	"driver.phone": string;
	"driver.physical_date": Date;
	"driver.planning_comment": string;
	"driver.preferred_days_out": number;
	"driver.prev_code": string;
	"driver.primary_agency": string;
	"driver.proximity_card": string;
	"driver.pta_date": Date;
	"driver.race": string;
	"driver.reason_for_leaving": string;
	"driver.record_pta": string;
	"driver.remark": string;
	"driver.reporting_status": string;
	"driver.return_home_flag": string;
	"driver.route_through_term": string;
	"driver.safety_meet_date": Date;
	"driver.safety_topic": string;
	"driver.security_date": Date;
	"driver.sex": string;
	"driver.shuttle_capable": string;
	"driver.site_id": string;
	"driver.social_security_no": string;
	"driver.speed": number;
	"driver.start_status_date": Date;
	"driver.state": string;
	"driver.status_code": string;
	"driver.stop_pta_update": string;
	"driver.tanks_endorsement": string;
	"driver.team_status": string;
	"driver.tenstreet_id": string;
	"driver.termination_date": Date;
	"driver.tractor_id": string;
	"driver.trainee": string;
	"driver.type_of": string;
	"driver.violation_comment": string;
	"driver.yard_move": string;
	"driver.zip": string;
	driver_id: string;
	"driver_manager_users.acct_lock_date": Date;
	"driver_manager_users.active_date": Date;
	"driver_manager_users.admin_user": string;
	"driver_manager_users.agent": string;
	"driver_manager_users.agree_fieldmarshal": Date;
	"driver_manager_users.agree_tailor": Date;
	"driver_manager_users.agree_tailor_ext": Date;
	"driver_manager_users.all_contacts": string;
	"driver_manager_users.allow_new_devices": string;
	"driver_manager_users.alternative_user": string;
	"driver_manager_users.ap_division_id": string;
	"driver_manager_users.appt_sched_id": string;
	"driver_manager_users.auth_subject": string;
	"driver_manager_users.auto_edit_type": string;
	"driver_manager_users.avail_tract_path": string;
	"driver_manager_users.avail_tract_sample": string;
	"driver_manager_users.available": string;
	"driver_manager_users.bridge_customer_access": string;
	"driver_manager_users.brokerage_divider": number;
	"driver_manager_users.brokerage_planning": string;
	"driver_manager_users.brokerage_planning2": string;
	"driver_manager_users.brokerage_planning3": string;
	"driver_manager_users.brokerage_planning4": string;
	"driver_manager_users.brokerage_planning_contnr": string;
	"driver_manager_users.call_list_profile": string;
	"driver_manager_users.carrier_call_list_id": string;
	"driver_manager_users.carrier_mgr_profil": string;
	"driver_manager_users.carrier_mgr_profil2": string;
	"driver_manager_users.carrier_mgr_profil3": string;
	"driver_manager_users.carrier_mgr_profil4": string;
	"driver_manager_users.cell_phone": string;
	"driver_manager_users.close_window": string;
	"driver_manager_users.commission_payee_id": string;
	"driver_manager_users.company_id": string;
	"driver_manager_users.company_name": string;
	"driver_manager_users.conf_cntr_template": number;
	"driver_manager_users.conf_template": number;
	"driver_manager_users.confirm_record": string;
	"driver_manager_users.contact_id": string;
	"driver_manager_users.continuous_radius": number;
	"driver_manager_users.crm_vs_profile": string;
	"driver_manager_users.csm_profile_id": string;
	"driver_manager_users.csm_profile_id2": string;
	"driver_manager_users.csm_profile_id3": string;
	"driver_manager_users.csm_profile_id4": string;
	"driver_manager_users.currency_reporting": string;
	"driver_manager_users.currency_transaction": string;
	"driver_manager_users.daily_advance_limits": string;
	"driver_manager_users.daily_brok_profile": string;
	"driver_manager_users.daily_snap_profile": string;
	"driver_manager_users.date_format": string;
	"driver_manager_users.default_search": number;
	"driver_manager_users.default_wirecode": string;
	"driver_manager_users.delivered_load_day": number;
	"driver_manager_users.department_id": string;
	"driver_manager_users.detention_profile_id": string;
	"driver_manager_users.detention_profile_id2": string;
	"driver_manager_users.detention_profile_id3": string;
	"driver_manager_users.detention_profile_id4": string;
	"driver_manager_users.disp_new_order_screen": string;
	"driver_manager_users.distance_calc_vendor": string;
	"driver_manager_users.dock_enable_wfmd_mode_swtch": string;
	"driver_manager_users.dock_login_id": string;
	"driver_manager_users.dragndrop_profile_id": string;
	"driver_manager_users.driver_manager_profile": string;
	"driver_manager_users.driver_manager_profile2": string;
	"driver_manager_users.driver_manager_profile3": string;
	"driver_manager_users.driver_manager_profile4": string;
	"driver_manager_users.driver_manager_vendor": string;
	"driver_manager_users.driver_managers": string;
	"driver_manager_users.drivers_wo_manager": string;
	"driver_manager_users.ds_cap_profile": string;
	"driver_manager_users.ds_mv_eta_profile": string;
	"driver_manager_users.ds_mv_eval_profile": string;
	"driver_manager_users.dsp_override_user": string;
	"driver_manager_users.email_address": string;
	"driver_manager_users.email_bcc": string;
	"driver_manager_users.email_client": string;
	"driver_manager_users.email_host": string;
	"driver_manager_users.email_imap_host": string;
	"driver_manager_users.email_imap_password": string;
	"driver_manager_users.email_imap_sent_folder": string;
	"driver_manager_users.email_imap_ssl": string;
	"driver_manager_users.email_imap_username": string;
	"driver_manager_users.email_override_company": string;
	"driver_manager_users.email_password": string;
	"driver_manager_users.email_port": number;
	"driver_manager_users.email_protocol": string;
	"driver_manager_users.email_use_sent_folder": string;
	"driver_manager_users.email_username": string;
	"driver_manager_users.employee_type": string;
	"driver_manager_users.enable_alerts": string;
	"driver_manager_users.extension": string;
	"driver_manager_users.external_password": string;
	"driver_manager_users.external_user_id": string;
	"driver_manager_users.failed_logins": number;
	"driver_manager_users.fax": string;
	"driver_manager_users.fileimport_profile": string;
	"driver_manager_users.findnear_vendor": string;
	"driver_manager_users.fleetmgmt_prof_id": string;
	"driver_manager_users.fm_account_id": string;
	"driver_manager_users.fm_can_view_metadata": string;
	"driver_manager_users.fm_profile_id": string;
	"driver_manager_users.fm_webhook_url": string;
	"driver_manager_users.ftl_revenue_code_id": string;
	"driver_manager_users.google_map_layer": string;
	"driver_manager_users.google_map_type": string;
	"driver_manager_users.grid_even_row_color": number;
	"driver_manager_users.grid_insert_sort": string;
	"driver_manager_users.grid_odd_row_color": number;
	"driver_manager_users.id": string;
	"driver_manager_users.img_category": string;
	"driver_manager_users.inactive_date": Date;
	"driver_manager_users.is_active": string;
	"driver_manager_users.is_clearer": string;
	"driver_manager_users.is_closer": string;
	"driver_manager_users.is_dock_supervisor": string;
	"driver_manager_users.is_dock_worker": string;
	"driver_manager_users.is_email_confirmed": string;
	"driver_manager_users.is_mcleod": string;
	"driver_manager_users.issue_atm_cash": string;
	"driver_manager_users.lock_status": string;
	"driver_manager_users.log_sql": string;
	"driver_manager_users.login_id": string;
	"driver_manager_users.ltl_carrier_brk_status": string;
	"driver_manager_users.ltl_mapping_vendor": string;
	"driver_manager_users.ltl_quote_template": number;
	"driver_manager_users.manifest_profile": string;
	"driver_manager_users.margin_percentage": number;
	"driver_manager_users.max_payment_code_amt": number;
	"driver_manager_users.max_payment_code_amt_c": string;
	"driver_manager_users.max_payment_code_amt_d": Date;
	"driver_manager_users.max_payment_code_amt_n": number;
	"driver_manager_users.max_payment_code_amt_r": number;
	"driver_manager_users.mc_position_vendor": string;
	"driver_manager_users.menu_tree_view": string;
	"driver_manager_users.mfa_device_id": string;
	"driver_manager_users.mfa_last_prompted": Date;
	"driver_manager_users.mfa_secret": string;
	"driver_manager_users.mfa_status": string;
	"driver_manager_users.mobcomm_profile_id": string;
	"driver_manager_users.mobile_pw_reset_token": string;
	"driver_manager_users.mobile_pw_token_expire_ms": number;
	"driver_manager_users.move_dates": string;
	"driver_manager_users.movement_map_vendor": string;
	"driver_manager_users.name": string;
	"driver_manager_users.notification": string;
	"driver_manager_users.notify_alerts": string;
	"driver_manager_users.notify_frequency": string;
	"driver_manager_users.notify_method": string;
	"driver_manager_users.notify_occurance": string;
	"driver_manager_users.operations_user_id": string;
	"driver_manager_users.order_mode": string;
	"driver_manager_users.order_planning2": string;
	"driver_manager_users.order_planning3": string;
	"driver_manager_users.order_planning4": string;
	"driver_manager_users.order_planning_vendor": string;
	"driver_manager_users.order_tran_request": string;
	"driver_manager_users.orderhist_profile": string;
	"driver_manager_users.outbound_notification": string;
	"driver_manager_users.override_vendor_division": string;
	"driver_manager_users.payee_id": string;
	"driver_manager_users.pbw_brokerage_planning": string;
	"driver_manager_users.phone": string;
	"driver_manager_users.planner": string;
	"driver_manager_users.planning": string;
	"driver_manager_users.planning_container": string;
	"driver_manager_users.planning_divider": number;
	"driver_manager_users.portal_admin_id": string;
	"driver_manager_users.primary_agency": string;
	"driver_manager_users.prompt_cont_moves": string;
	"driver_manager_users.quote_comp_act_create": string;
	"driver_manager_users.quote_comp_act_id": string;
	"driver_manager_users.quote_pend_act_create": string;
	"driver_manager_users.quote_pend_act_id": string;
	"driver_manager_users.quote_template": number;
	"driver_manager_users.rapid_alert_expand": string;
	"driver_manager_users.rapid_alert_sound": string;
	"driver_manager_users.receive_alerts": string;
	"driver_manager_users.recruiting_profile": string;
	"driver_manager_users.request_location_vendor": string;
	"driver_manager_users.revenue_code_id": string;
	"driver_manager_users.route_detail_vendor": string;
	"driver_manager_users.save_screen_sizes": string;
	"driver_manager_users.search_history_limit": number;
	"driver_manager_users.sec_ans1": string;
	"driver_manager_users.sec_ans2": string;
	"driver_manager_users.sec_question1": number;
	"driver_manager_users.sec_question2": number;
	"driver_manager_users.seg_alloc_code": string;
	"driver_manager_users.sel_text_on_focus": string;
	"driver_manager_users.show_active": string;
	"driver_manager_users.show_google_route": string;
	"driver_manager_users.show_inactive": string;
	"driver_manager_users.single_point_vendor": string;
	"driver_manager_users.support_inactivate_date": Date;
	"driver_manager_users.system_tray": string;
	"driver_manager_users.table_even_row_color": string;
	"driver_manager_users.table_odd_row_color": string;
	"driver_manager_users.telephony_access_token": string;
	"driver_manager_users.telephony_access_token_exp": Date;
	"driver_manager_users.telephony_number": string;
	"driver_manager_users.telephony_password": string;
	"driver_manager_users.telephony_refresh_token": string;
	"driver_manager_users.telephony_refresh_token_exp": Date;
	"driver_manager_users.terminal_id": string;
	"driver_manager_users.time_format": string;
	"driver_manager_users.token_key": number;
	"driver_manager_users.toolbar_multi_rows": string;
	"driver_manager_users.toolbar_setting": string;
	"driver_manager_users.trailer_loan_profile_id": string;
	"driver_manager_users.trailer_wash_loc": string;
	"driver_manager_users.trailer_wash_user": string;
	"driver_manager_users.trimble_map_traffic": string;
	"driver_manager_users.tw_seg_code": string;
	"driver_manager_users.tw_ticket_template": number;
	"driver_manager_users.type_agents": string;
	"driver_manager_users.type_carrier": string;
	"driver_manager_users.type_company_drs": string;
	"driver_manager_users.type_number": string;
	"driver_manager_users.type_owner_oper": string;
	"driver_manager_users.user_group": string;
	"driver_manager_users.vendor_user_id": string;
	"driver_manager_users.view_movement_vendor": string;
	"driver_manager_users.waterfall_default_rt_guide": string;
	"driver_manager_users.waterfall_include_rates": string;
	"driver_manager_users.waterfall_include_rt_guides": string;
	"driver_manager_users.waterfall_prevent_tendering": string;
	"driver_manager_users.web_acct_status": string;
	"driver_manager_users.web_agent": string;
	"driver_manager_users.web_created_on": Date;
	"driver_manager_users.web_enabled_on": Date;
	"driver_manager_users.web_last_login": Date;
	"driver_manager_users.web_locked_on": Date;
	"driver_manager_users.web_map": string;
	"driver_manager_users.web_password": string;
	"driver_manager_users.web_user_id": string;
	"driver_manager_users.web_user_type": string;
	"driver_manager_users.window_location": string;
	"driver_manager_users.windows_login": string;
	"driver_manager_users.wire_trans_per_day": number;
	"driver_manager_users.zone_mapping_vendor": string;
	dsp_comment: string;
	edi_code_version: string;
	"edi_customer.alt_partner_id": string;
	"edi_customer.carrier": string;
	"edi_customer.check_manual_order": string;
	"edi_customer.company_id": string;
	"edi_customer.credit_rebill_filter": string;
	"edi_customer.customer_id": string;
	"edi_customer.default_correction_ind": string;
	"edi_customer.direction": string;
	"edi_customer.hold_214_for_reply": string;
	"edi_customer.id": string;
	"edi_customer.partner_id": string;
	"edi_customer.partner_name": string;
	"edi_customer.require_correction_ind": string;
	"edi_customer.scac": string;
	"edi_customer.time_zone": string;
	"edi_customer.transaction_set": string;
	"edi_customer.transaction_type": string;
	"edi_customer.version": string;
	edi_element_id: string;
	"edi_partner_code.code_enabled": string;
	"edi_partner_code.company_id": string;
	"edi_partner_code.description": string;
	"edi_partner_code.element_id": string;
	"edi_partner_code.fault_of_carrier_or_driver": string;
	"edi_partner_code.id": string;
	"edi_partner_code.include_mobile_pu": string;
	"edi_partner_code.include_mobile_so": string;
	"edi_partner_code.partner_id": string;
	"edi_partner_code.send_to_driver": string;
	"edi_partner_code.standard_code": string;
	"edi_partner_code.transaction_set": string;
	"edi_partner_code.version": string;
	edi_standard_code: string;
	"edi_standard_code.company_id": string;
	"edi_standard_code.description": string;
	"edi_standard_code.element_id": string;
	"edi_standard_code.standard_code": string;
	"edi_standard_code.version": string;
	"edi_stop.actual_arrival": Date;
	"edi_stop.actual_departure": Date;
	"edi_stop.address": string;
	"edi_stop.address2": string;
	"edi_stop.appointment_status_id": string;
	"edi_stop.appt_required": string;
	"edi_stop.cases": number;
	"edi_stop.city_id": number;
	"edi_stop.city_name": string;
	"edi_stop.company_id": string;
	"edi_stop.confirmed": string;
	"edi_stop.contact_email": string;
	"edi_stop.contact_name": string;
	"edi_stop.dist_from_prev": number;
	"edi_stop.dist_from_prev_um": string;
	"edi_stop.driver_load_unload": string;
	"edi_stop.edi_code": string;
	"edi_stop.edi_loc_code": string;
	"edi_stop.eta": Date;
	"edi_stop.hub": number;
	"edi_stop.id": string;
	"edi_stop.latitude": number;
	"edi_stop.location_id": string;
	"edi_stop.location_name": string;
	"edi_stop.longitude": number;
	"edi_stop.manifest_reg_uid": number;
	"edi_stop.movement_id": string;
	"edi_stop.movement_sequence": number;
	"edi_stop.operational_status": string;
	"edi_stop.order_id": string;
	"edi_stop.order_sequence": number;
	"edi_stop.orig_sched_early": Date;
	"edi_stop.orig_sched_late": Date;
	"edi_stop.pallets_dropped": number;
	"edi_stop.pallets_picked_up": number;
	"edi_stop.parent_trans_type": string;
	"edi_stop.payment_code_reviewed": string;
	"edi_stop.phone": string;
	"edi_stop.ponum": string;
	"edi_stop.projected_arrival": Date;
	"edi_stop.refno": string;
	"edi_stop.sched_arrive_early": Date;
	"edi_stop.sched_arrive_late": Date;
	"edi_stop.seal": string;
	"edi_stop.showas_address": string;
	"edi_stop.showas_address2": string;
	"edi_stop.showas_city_id": number;
	"edi_stop.showas_city_name": string;
	"edi_stop.showas_location_id": string;
	"edi_stop.showas_location_name": string;
	"edi_stop.showas_state": string;
	"edi_stop.showas_zip_code": string;
	"edi_stop.signed_for_name": string;
	"edi_stop.state": string;
	"edi_stop.status": string;
	"edi_stop.stop_type": string;
	"edi_stop.volume": number;
	"edi_stop.volume_um": string;
	"edi_stop.weight": number;
	"edi_stop.weight_um": string;
	"edi_stop.zip_code": string;
	"edi_stop.zone_id": string;
	entered_date: Date;
	entered_user_id: string;
	"entered_users.acct_lock_date": Date;
	"entered_users.active_date": Date;
	"entered_users.admin_user": string;
	"entered_users.agent": string;
	"entered_users.agree_fieldmarshal": Date;
	"entered_users.agree_tailor": Date;
	"entered_users.agree_tailor_ext": Date;
	"entered_users.all_contacts": string;
	"entered_users.allow_new_devices": string;
	"entered_users.alternative_user": string;
	"entered_users.ap_division_id": string;
	"entered_users.appt_sched_id": string;
	"entered_users.auth_subject": string;
	"entered_users.auto_edit_type": string;
	"entered_users.avail_tract_path": string;
	"entered_users.avail_tract_sample": string;
	"entered_users.available": string;
	"entered_users.bridge_customer_access": string;
	"entered_users.brokerage_divider": number;
	"entered_users.brokerage_planning": string;
	"entered_users.brokerage_planning2": string;
	"entered_users.brokerage_planning3": string;
	"entered_users.brokerage_planning4": string;
	"entered_users.brokerage_planning_contnr": string;
	"entered_users.call_list_profile": string;
	"entered_users.carrier_call_list_id": string;
	"entered_users.carrier_mgr_profil": string;
	"entered_users.carrier_mgr_profil2": string;
	"entered_users.carrier_mgr_profil3": string;
	"entered_users.carrier_mgr_profil4": string;
	"entered_users.cell_phone": string;
	"entered_users.close_window": string;
	"entered_users.commission_payee_id": string;
	"entered_users.company_id": string;
	"entered_users.company_name": string;
	"entered_users.conf_cntr_template": number;
	"entered_users.conf_template": number;
	"entered_users.confirm_record": string;
	"entered_users.contact_id": string;
	"entered_users.continuous_radius": number;
	"entered_users.crm_vs_profile": string;
	"entered_users.csm_profile_id": string;
	"entered_users.csm_profile_id2": string;
	"entered_users.csm_profile_id3": string;
	"entered_users.csm_profile_id4": string;
	"entered_users.currency_reporting": string;
	"entered_users.currency_transaction": string;
	"entered_users.daily_advance_limits": string;
	"entered_users.daily_brok_profile": string;
	"entered_users.daily_snap_profile": string;
	"entered_users.date_format": string;
	"entered_users.default_search": number;
	"entered_users.default_wirecode": string;
	"entered_users.delivered_load_day": number;
	"entered_users.department_id": string;
	"entered_users.detention_profile_id": string;
	"entered_users.detention_profile_id2": string;
	"entered_users.detention_profile_id3": string;
	"entered_users.detention_profile_id4": string;
	"entered_users.disp_new_order_screen": string;
	"entered_users.distance_calc_vendor": string;
	"entered_users.dock_enable_wfmd_mode_swtch": string;
	"entered_users.dock_login_id": string;
	"entered_users.dragndrop_profile_id": string;
	"entered_users.driver_manager_profile": string;
	"entered_users.driver_manager_profile2": string;
	"entered_users.driver_manager_profile3": string;
	"entered_users.driver_manager_profile4": string;
	"entered_users.driver_manager_vendor": string;
	"entered_users.driver_managers": string;
	"entered_users.drivers_wo_manager": string;
	"entered_users.ds_cap_profile": string;
	"entered_users.ds_mv_eta_profile": string;
	"entered_users.ds_mv_eval_profile": string;
	"entered_users.dsp_override_user": string;
	"entered_users.email_address": string;
	"entered_users.email_bcc": string;
	"entered_users.email_client": string;
	"entered_users.email_host": string;
	"entered_users.email_imap_host": string;
	"entered_users.email_imap_password": string;
	"entered_users.email_imap_sent_folder": string;
	"entered_users.email_imap_ssl": string;
	"entered_users.email_imap_username": string;
	"entered_users.email_override_company": string;
	"entered_users.email_password": string;
	"entered_users.email_port": number;
	"entered_users.email_protocol": string;
	"entered_users.email_use_sent_folder": string;
	"entered_users.email_username": string;
	"entered_users.employee_type": string;
	"entered_users.enable_alerts": string;
	"entered_users.extension": string;
	"entered_users.external_password": string;
	"entered_users.external_user_id": string;
	"entered_users.failed_logins": number;
	"entered_users.fax": string;
	"entered_users.fileimport_profile": string;
	"entered_users.findnear_vendor": string;
	"entered_users.fleetmgmt_prof_id": string;
	"entered_users.fm_account_id": string;
	"entered_users.fm_can_view_metadata": string;
	"entered_users.fm_profile_id": string;
	"entered_users.fm_webhook_url": string;
	"entered_users.ftl_revenue_code_id": string;
	"entered_users.google_map_layer": string;
	"entered_users.google_map_type": string;
	"entered_users.grid_even_row_color": number;
	"entered_users.grid_insert_sort": string;
	"entered_users.grid_odd_row_color": number;
	"entered_users.id": string;
	"entered_users.img_category": string;
	"entered_users.inactive_date": Date;
	"entered_users.is_active": string;
	"entered_users.is_clearer": string;
	"entered_users.is_closer": string;
	"entered_users.is_dock_supervisor": string;
	"entered_users.is_dock_worker": string;
	"entered_users.is_email_confirmed": string;
	"entered_users.is_mcleod": string;
	"entered_users.issue_atm_cash": string;
	"entered_users.lock_status": string;
	"entered_users.log_sql": string;
	"entered_users.login_id": string;
	"entered_users.ltl_carrier_brk_status": string;
	"entered_users.ltl_mapping_vendor": string;
	"entered_users.ltl_quote_template": number;
	"entered_users.manifest_profile": string;
	"entered_users.margin_percentage": number;
	"entered_users.max_payment_code_amt": number;
	"entered_users.max_payment_code_amt_c": string;
	"entered_users.max_payment_code_amt_d": Date;
	"entered_users.max_payment_code_amt_n": number;
	"entered_users.max_payment_code_amt_r": number;
	"entered_users.mc_position_vendor": string;
	"entered_users.menu_tree_view": string;
	"entered_users.mfa_device_id": string;
	"entered_users.mfa_last_prompted": Date;
	"entered_users.mfa_secret": string;
	"entered_users.mfa_status": string;
	"entered_users.mobcomm_profile_id": string;
	"entered_users.mobile_pw_reset_token": string;
	"entered_users.mobile_pw_token_expire_ms": number;
	"entered_users.move_dates": string;
	"entered_users.movement_map_vendor": string;
	"entered_users.name": string;
	"entered_users.notification": string;
	"entered_users.notify_alerts": string;
	"entered_users.notify_frequency": string;
	"entered_users.notify_method": string;
	"entered_users.notify_occurance": string;
	"entered_users.operations_user_id": string;
	"entered_users.order_mode": string;
	"entered_users.order_planning2": string;
	"entered_users.order_planning3": string;
	"entered_users.order_planning4": string;
	"entered_users.order_planning_vendor": string;
	"entered_users.order_tran_request": string;
	"entered_users.orderhist_profile": string;
	"entered_users.outbound_notification": string;
	"entered_users.override_vendor_division": string;
	"entered_users.payee_id": string;
	"entered_users.pbw_brokerage_planning": string;
	"entered_users.phone": string;
	"entered_users.planner": string;
	"entered_users.planning": string;
	"entered_users.planning_container": string;
	"entered_users.planning_divider": number;
	"entered_users.portal_admin_id": string;
	"entered_users.primary_agency": string;
	"entered_users.prompt_cont_moves": string;
	"entered_users.quote_comp_act_create": string;
	"entered_users.quote_comp_act_id": string;
	"entered_users.quote_pend_act_create": string;
	"entered_users.quote_pend_act_id": string;
	"entered_users.quote_template": number;
	"entered_users.rapid_alert_expand": string;
	"entered_users.rapid_alert_sound": string;
	"entered_users.receive_alerts": string;
	"entered_users.recruiting_profile": string;
	"entered_users.request_location_vendor": string;
	"entered_users.revenue_code_id": string;
	"entered_users.route_detail_vendor": string;
	"entered_users.save_screen_sizes": string;
	"entered_users.search_history_limit": number;
	"entered_users.sec_ans1": string;
	"entered_users.sec_ans2": string;
	"entered_users.sec_question1": number;
	"entered_users.sec_question2": number;
	"entered_users.seg_alloc_code": string;
	"entered_users.sel_text_on_focus": string;
	"entered_users.show_active": string;
	"entered_users.show_google_route": string;
	"entered_users.show_inactive": string;
	"entered_users.single_point_vendor": string;
	"entered_users.support_inactivate_date": Date;
	"entered_users.system_tray": string;
	"entered_users.table_even_row_color": string;
	"entered_users.table_odd_row_color": string;
	"entered_users.telephony_access_token": string;
	"entered_users.telephony_access_token_exp": Date;
	"entered_users.telephony_number": string;
	"entered_users.telephony_password": string;
	"entered_users.telephony_refresh_token": string;
	"entered_users.telephony_refresh_token_exp": Date;
	"entered_users.terminal_id": string;
	"entered_users.time_format": string;
	"entered_users.token_key": number;
	"entered_users.toolbar_multi_rows": string;
	"entered_users.toolbar_setting": string;
	"entered_users.trailer_loan_profile_id": string;
	"entered_users.trailer_wash_loc": string;
	"entered_users.trailer_wash_user": string;
	"entered_users.trimble_map_traffic": string;
	"entered_users.tw_seg_code": string;
	"entered_users.tw_ticket_template": number;
	"entered_users.type_agents": string;
	"entered_users.type_carrier": string;
	"entered_users.type_company_drs": string;
	"entered_users.type_number": string;
	"entered_users.type_owner_oper": string;
	"entered_users.user_group": string;
	"entered_users.vendor_user_id": string;
	"entered_users.view_movement_vendor": string;
	"entered_users.waterfall_default_rt_guide": string;
	"entered_users.waterfall_include_rates": string;
	"entered_users.waterfall_include_rt_guides": string;
	"entered_users.waterfall_prevent_tendering": string;
	"entered_users.web_acct_status": string;
	"entered_users.web_agent": string;
	"entered_users.web_created_on": Date;
	"entered_users.web_enabled_on": Date;
	"entered_users.web_last_login": Date;
	"entered_users.web_locked_on": Date;
	"entered_users.web_map": string;
	"entered_users.web_password": string;
	"entered_users.web_user_id": string;
	"entered_users.web_user_type": string;
	"entered_users.window_location": string;
	"entered_users.windows_login": string;
	"entered_users.wire_trans_per_day": number;
	"entered_users.zone_mapping_vendor": string;
	fault_of_carrier_or_driver: string;
	fleet_manager: string;
	id: string;
	is_reportable: string;
	minutes_late: number;
	movement_id: string;
	name: string;
	operations_user: string;
	"operations_users.acct_lock_date": Date;
	"operations_users.active_date": Date;
	"operations_users.admin_user": string;
	"operations_users.agent": string;
	"operations_users.agree_fieldmarshal": Date;
	"operations_users.agree_tailor": Date;
	"operations_users.agree_tailor_ext": Date;
	"operations_users.all_contacts": string;
	"operations_users.allow_new_devices": string;
	"operations_users.alternative_user": string;
	"operations_users.ap_division_id": string;
	"operations_users.appt_sched_id": string;
	"operations_users.auth_subject": string;
	"operations_users.auto_edit_type": string;
	"operations_users.avail_tract_path": string;
	"operations_users.avail_tract_sample": string;
	"operations_users.available": string;
	"operations_users.bridge_customer_access": string;
	"operations_users.brokerage_divider": number;
	"operations_users.brokerage_planning": string;
	"operations_users.brokerage_planning2": string;
	"operations_users.brokerage_planning3": string;
	"operations_users.brokerage_planning4": string;
	"operations_users.brokerage_planning_contnr": string;
	"operations_users.call_list_profile": string;
	"operations_users.carrier_call_list_id": string;
	"operations_users.carrier_mgr_profil": string;
	"operations_users.carrier_mgr_profil2": string;
	"operations_users.carrier_mgr_profil3": string;
	"operations_users.carrier_mgr_profil4": string;
	"operations_users.cell_phone": string;
	"operations_users.close_window": string;
	"operations_users.commission_payee_id": string;
	"operations_users.company_id": string;
	"operations_users.company_name": string;
	"operations_users.conf_cntr_template": number;
	"operations_users.conf_template": number;
	"operations_users.confirm_record": string;
	"operations_users.contact_id": string;
	"operations_users.continuous_radius": number;
	"operations_users.crm_vs_profile": string;
	"operations_users.csm_profile_id": string;
	"operations_users.csm_profile_id2": string;
	"operations_users.csm_profile_id3": string;
	"operations_users.csm_profile_id4": string;
	"operations_users.currency_reporting": string;
	"operations_users.currency_transaction": string;
	"operations_users.daily_advance_limits": string;
	"operations_users.daily_brok_profile": string;
	"operations_users.daily_snap_profile": string;
	"operations_users.date_format": string;
	"operations_users.default_search": number;
	"operations_users.default_wirecode": string;
	"operations_users.delivered_load_day": number;
	"operations_users.department_id": string;
	"operations_users.detention_profile_id": string;
	"operations_users.detention_profile_id2": string;
	"operations_users.detention_profile_id3": string;
	"operations_users.detention_profile_id4": string;
	"operations_users.disp_new_order_screen": string;
	"operations_users.distance_calc_vendor": string;
	"operations_users.dock_enable_wfmd_mode_swtch": string;
	"operations_users.dock_login_id": string;
	"operations_users.dragndrop_profile_id": string;
	"operations_users.driver_manager_profile": string;
	"operations_users.driver_manager_profile2": string;
	"operations_users.driver_manager_profile3": string;
	"operations_users.driver_manager_profile4": string;
	"operations_users.driver_manager_vendor": string;
	"operations_users.driver_managers": string;
	"operations_users.drivers_wo_manager": string;
	"operations_users.ds_cap_profile": string;
	"operations_users.ds_mv_eta_profile": string;
	"operations_users.ds_mv_eval_profile": string;
	"operations_users.dsp_override_user": string;
	"operations_users.email_address": string;
	"operations_users.email_bcc": string;
	"operations_users.email_client": string;
	"operations_users.email_host": string;
	"operations_users.email_imap_host": string;
	"operations_users.email_imap_password": string;
	"operations_users.email_imap_sent_folder": string;
	"operations_users.email_imap_ssl": string;
	"operations_users.email_imap_username": string;
	"operations_users.email_override_company": string;
	"operations_users.email_password": string;
	"operations_users.email_port": number;
	"operations_users.email_protocol": string;
	"operations_users.email_use_sent_folder": string;
	"operations_users.email_username": string;
	"operations_users.employee_type": string;
	"operations_users.enable_alerts": string;
	"operations_users.extension": string;
	"operations_users.external_password": string;
	"operations_users.external_user_id": string;
	"operations_users.failed_logins": number;
	"operations_users.fax": string;
	"operations_users.fileimport_profile": string;
	"operations_users.findnear_vendor": string;
	"operations_users.fleetmgmt_prof_id": string;
	"operations_users.fm_account_id": string;
	"operations_users.fm_can_view_metadata": string;
	"operations_users.fm_profile_id": string;
	"operations_users.fm_webhook_url": string;
	"operations_users.ftl_revenue_code_id": string;
	"operations_users.google_map_layer": string;
	"operations_users.google_map_type": string;
	"operations_users.grid_even_row_color": number;
	"operations_users.grid_insert_sort": string;
	"operations_users.grid_odd_row_color": number;
	"operations_users.id": string;
	"operations_users.img_category": string;
	"operations_users.inactive_date": Date;
	"operations_users.is_active": string;
	"operations_users.is_clearer": string;
	"operations_users.is_closer": string;
	"operations_users.is_dock_supervisor": string;
	"operations_users.is_dock_worker": string;
	"operations_users.is_email_confirmed": string;
	"operations_users.is_mcleod": string;
	"operations_users.issue_atm_cash": string;
	"operations_users.lock_status": string;
	"operations_users.log_sql": string;
	"operations_users.login_id": string;
	"operations_users.ltl_carrier_brk_status": string;
	"operations_users.ltl_mapping_vendor": string;
	"operations_users.ltl_quote_template": number;
	"operations_users.manifest_profile": string;
	"operations_users.margin_percentage": number;
	"operations_users.max_payment_code_amt": number;
	"operations_users.max_payment_code_amt_c": string;
	"operations_users.max_payment_code_amt_d": Date;
	"operations_users.max_payment_code_amt_n": number;
	"operations_users.max_payment_code_amt_r": number;
	"operations_users.mc_position_vendor": string;
	"operations_users.menu_tree_view": string;
	"operations_users.mfa_device_id": string;
	"operations_users.mfa_last_prompted": Date;
	"operations_users.mfa_secret": string;
	"operations_users.mfa_status": string;
	"operations_users.mobcomm_profile_id": string;
	"operations_users.mobile_pw_reset_token": string;
	"operations_users.mobile_pw_token_expire_ms": number;
	"operations_users.move_dates": string;
	"operations_users.movement_map_vendor": string;
	"operations_users.name": string;
	"operations_users.notification": string;
	"operations_users.notify_alerts": string;
	"operations_users.notify_frequency": string;
	"operations_users.notify_method": string;
	"operations_users.notify_occurance": string;
	"operations_users.operations_user_id": string;
	"operations_users.order_mode": string;
	"operations_users.order_planning2": string;
	"operations_users.order_planning3": string;
	"operations_users.order_planning4": string;
	"operations_users.order_planning_vendor": string;
	"operations_users.order_tran_request": string;
	"operations_users.orderhist_profile": string;
	"operations_users.outbound_notification": string;
	"operations_users.override_vendor_division": string;
	"operations_users.payee_id": string;
	"operations_users.pbw_brokerage_planning": string;
	"operations_users.phone": string;
	"operations_users.planner": string;
	"operations_users.planning": string;
	"operations_users.planning_container": string;
	"operations_users.planning_divider": number;
	"operations_users.portal_admin_id": string;
	"operations_users.primary_agency": string;
	"operations_users.prompt_cont_moves": string;
	"operations_users.quote_comp_act_create": string;
	"operations_users.quote_comp_act_id": string;
	"operations_users.quote_pend_act_create": string;
	"operations_users.quote_pend_act_id": string;
	"operations_users.quote_template": number;
	"operations_users.rapid_alert_expand": string;
	"operations_users.rapid_alert_sound": string;
	"operations_users.receive_alerts": string;
	"operations_users.recruiting_profile": string;
	"operations_users.request_location_vendor": string;
	"operations_users.revenue_code_id": string;
	"operations_users.route_detail_vendor": string;
	"operations_users.save_screen_sizes": string;
	"operations_users.search_history_limit": number;
	"operations_users.sec_ans1": string;
	"operations_users.sec_ans2": string;
	"operations_users.sec_question1": number;
	"operations_users.sec_question2": number;
	"operations_users.seg_alloc_code": string;
	"operations_users.sel_text_on_focus": string;
	"operations_users.show_active": string;
	"operations_users.show_google_route": string;
	"operations_users.show_inactive": string;
	"operations_users.single_point_vendor": string;
	"operations_users.support_inactivate_date": Date;
	"operations_users.system_tray": string;
	"operations_users.table_even_row_color": string;
	"operations_users.table_odd_row_color": string;
	"operations_users.telephony_access_token": string;
	"operations_users.telephony_access_token_exp": Date;
	"operations_users.telephony_number": string;
	"operations_users.telephony_password": string;
	"operations_users.telephony_refresh_token": string;
	"operations_users.telephony_refresh_token_exp": Date;
	"operations_users.terminal_id": string;
	"operations_users.time_format": string;
	"operations_users.token_key": number;
	"operations_users.toolbar_multi_rows": string;
	"operations_users.toolbar_setting": string;
	"operations_users.trailer_loan_profile_id": string;
	"operations_users.trailer_wash_loc": string;
	"operations_users.trailer_wash_user": string;
	"operations_users.trimble_map_traffic": string;
	"operations_users.tw_seg_code": string;
	"operations_users.tw_ticket_template": number;
	"operations_users.type_agents": string;
	"operations_users.type_carrier": string;
	"operations_users.type_company_drs": string;
	"operations_users.type_number": string;
	"operations_users.type_owner_oper": string;
	"operations_users.user_group": string;
	"operations_users.vendor_user_id": string;
	"operations_users.view_movement_vendor": string;
	"operations_users.waterfall_default_rt_guide": string;
	"operations_users.waterfall_include_rates": string;
	"operations_users.waterfall_include_rt_guides": string;
	"operations_users.waterfall_prevent_tendering": string;
	"operations_users.web_acct_status": string;
	"operations_users.web_agent": string;
	"operations_users.web_created_on": Date;
	"operations_users.web_enabled_on": Date;
	"operations_users.web_last_login": Date;
	"operations_users.web_locked_on": Date;
	"operations_users.web_map": string;
	"operations_users.web_password": string;
	"operations_users.web_user_id": string;
	"operations_users.web_user_type": string;
	"operations_users.window_location": string;
	"operations_users.windows_login": string;
	"operations_users.wire_trans_per_day": number;
	"operations_users.zone_mapping_vendor": string;
	order_id: string;
	"orders.actual_reefer_profile": string;
	"orders.agency_id": string;
	"orders.agent_payee_id": string;
	"orders.all_vendors_enabled": string;
	"orders.allow_relay": string;
	"orders.autorate_status": string;
	"orders.bill_date": Date;
	"orders.bill_distance": number;
	"orders.bill_distance_um": string;
	"orders.billing_empty_distance": number;
	"orders.billing_empty_distance_um": string;
	"orders.billing_loaded_distance": number;
	"orders.billing_loaded_distance_um": string;
	"orders.billing_user_id": string;
	"orders.blnum": string;
	"orders.bol_note": string;
	"orders.bol_received": string;
	"orders.bol_recv_date": Date;
	"orders.booking_no": string;
	"orders.booking_number": string;
	"orders.brk_qual_profile": string;
	"orders.broker_location_id": string;
	"orders.brokerage_workflow_id": string;
	"orders.cbp_crossing_date": Date;
	"orders.cbp_crossing_location_id": string;
	"orders.cbp_crossing_reason": string;
	"orders.cbsa_crossing_date": Date;
	"orders.cbsa_crossing_location_id": string;
	"orders.cbsa_crossing_reason": string;
	"orders.cc_fuel_revenue": number;
	"orders.cc_fuel_revenue_c": string;
	"orders.cc_fuel_revenue_d": Date;
	"orders.cc_fuel_revenue_n": number;
	"orders.cc_fuel_revenue_r": number;
	"orders.cc_net_revenue": number;
	"orders.cc_net_revenue_c": string;
	"orders.cc_net_revenue_d": Date;
	"orders.cc_net_revenue_n": number;
	"orders.cc_net_revenue_r": number;
	"orders.cc_pro_nbr": string;
	"orders.cobroker_location_id": string;
	"orders.collection_method": string;
	"orders.com_setpnt_temp": number;
	"orders.com_setpnt_temp_dt": Date;
	"orders.com_setpnt_temp_um": string;
	"orders.commitment_id": string;
	"orders.commodity": string;
	"orders.commodity_id": string;
	"orders.company_id": string;
	"orders.consignee_refno": string;
	"orders.consignee_stop_id": string;
	"orders.container": string;
	"orders.container_planned": string;
	"orders.container_type_id": string;
	"orders.controlling_carrier_code": string;
	"orders.copy_from_company": string;
	"orders.copy_from_order_id": string;
	"orders.copy_to_company": string;
	"orders.copy_to_order_id": string;
	"orders.ctrl_party_id": string;
	"orders.cube": number;
	"orders.curr_movement_id": string;
	"orders.cust_order_no": string;
	"orders.customer_id": string;
	"orders.declared_val": number;
	"orders.def_move_type": string;
	"orders.default_match_id": string;
	"orders.dim_height": string;
	"orders.dim_length": string;
	"orders.dim_surcharge": number;
	"orders.dim_surcharge_c": string;
	"orders.dim_surcharge_d": Date;
	"orders.dim_surcharge_n": number;
	"orders.dim_surcharge_r": number;
	"orders.dim_width": string;
	"orders.dispatch_opt": string;
	"orders.dl_team_reqd": string;
	"orders.dray_del_date": Date;
	"orders.dray_del_pay": number;
	"orders.dray_del_pay_c": string;
	"orders.dray_del_pay_d": Date;
	"orders.dray_del_pay_n": number;
	"orders.dray_del_pay_r": number;
	"orders.dray_del_payee": string;
	"orders.dray_del_xfer_dt": Date;
	"orders.dray_pu_date": Date;
	"orders.dray_pu_pay": number;
	"orders.dray_pu_pay_c": string;
	"orders.dray_pu_pay_d": Date;
	"orders.dray_pu_pay_n": number;
	"orders.dray_pu_pay_r": number;
	"orders.dray_pu_payee": string;
	"orders.dray_pu_xfer_dt": Date;
	"orders.eir1_no": string;
	"orders.eir2_no": string;
	"orders.entered_user_id": string;
	"orders.equipment_type_id": string;
	"orders.equipment_type_options": string;
	"orders.est_tolls": number;
	"orders.est_tolls_c": string;
	"orders.est_tolls_d": Date;
	"orders.est_tolls_n": number;
	"orders.est_tolls_r": number;
	"orders.excise_disable_update": string;
	"orders.excise_taxable": string;
	"orders.excisetax_total": number;
	"orders.excisetax_total_c": string;
	"orders.excisetax_total_d": Date;
	"orders.excisetax_total_n": number;
	"orders.excisetax_total_r": number;
	"orders.external_invoiceno": string;
	"orders.extra_deliveries": number;
	"orders.extra_pickups": number;
	"orders.floor_loaded_freight": string;
	"orders.force_assign": string;
	"orders.forwd_location_id": string;
	"orders.free_days": number;
	"orders.freight_charge": number;
	"orders.freight_charge_c": string;
	"orders.freight_charge_d": Date;
	"orders.freight_charge_n": number;
	"orders.freight_charge_r": number;
	"orders.hazmat": string;
	"orders.hazmat_code": string;
	"orders.high_value": string;
	"orders.hold_reason": string;
	"orders.ic_company_from": string;
	"orders.ic_movement_from": string;
	"orders.ic_order_from": string;
	"orders.id": string;
	"orders.image_is_present": string;
	"orders.import_export": string;
	"orders.include_split_point": string;
	"orders.intelliset": string;
	"orders.invoice_recv_date": Date;
	"orders.is_auto_tonu": string;
	"orders.is_autorate_dist": string;
	"orders.is_container": string;
	"orders.is_dedicated": string;
	"orders.is_intercompany": string;
	"orders.is_local_mile": string;
	"orders.is_requested": string;
	"orders.is_tonu": string;
	"orders.jag_carrier_id": string;
	"orders.jag_cost_rate_id": number;
	"orders.ldport_location_id": string;
	"orders.linear_feet_avail": number;
	"orders.load_date": Date;
	"orders.loadboard": string;
	"orders.loadboard_post_movement_id": string;
	"orders.lock_miles": string;
	"orders.ltl": string;
	"orders.markup_flat": number;
	"orders.markup_flat_c": string;
	"orders.markup_flat_d": Date;
	"orders.markup_flat_n": number;
	"orders.markup_flat_r": number;
	"orders.markup_percent": number;
	"orders.master_order_id": string;
	"orders.master_sequence": number;
	"orders.next_rebill": string;
	"orders.nte_lp_num": string;
	"orders.nte_lp_qual": string;
	"orders.on_hold": string;
	"orders.operational_status": string;
	"orders.operations_user": string;
	"orders.optimize": string;
	"orders.optiset": string;
	"orders.order_mode": string;
	"orders.order_type_id": string;
	"orders.order_value": number;
	"orders.order_value_c": string;
	"orders.order_value_d": Date;
	"orders.order_value_n": number;
	"orders.order_value_r": number;
	"orders.ordered_by": string;
	"orders.ordered_by_id": string;
	"orders.ordered_date": Date;
	"orders.ordered_method": string;
	"orders.orig_dest_rate_id": string;
	"orders.otherchargetotal": number;
	"orders.otherchargetotal_c": string;
	"orders.otherchargetotal_d": Date;
	"orders.otherchargetotal_n": number;
	"orders.otherchargetotal_r": number;
	"orders.override_arrive_early": Date;
	"orders.override_arrive_late": Date;
	"orders.override_posting_city_id": number;
	"orders.pallets_how_many": number;
	"orders.pallets_required": string;
	"orders.pay_gross": number;
	"orders.pay_gross_c": string;
	"orders.pay_gross_d": Date;
	"orders.pay_gross_n": number;
	"orders.pay_gross_r": number;
	"orders.pick_up_no": string;
	"orders.pieces": number;
	"orders.placard_required": string;
	"orders.planning_comment": string;
	"orders.pnn_callback": string;
	"orders.pnn_comment": string;
	"orders.pnn_comment2": string;
	"orders.pnn_loadboard_user_id": string;
	"orders.pnn_post_type": string;
	"orders.pnn_rate": number;
	"orders.pnn_rate_type": string;
	"orders.pnn_trailer_length": number;
	"orders.pnn_trailer_width": number;
	"orders.ponum": string;
	"orders.port": string;
	"orders.port_of_discharge": string;
	"orders.preferred_vendors": string;
	"orders.preload_trailer_id": string;
	"orders.preloaded": string;
	"orders.rate": number;
	"orders.rate_currency_type": string;
	"orders.rate_id": number;
	"orders.rate_min_weight": number;
	"orders.rate_min_weight_um": string;
	"orders.rate_source": string;
	"orders.rate_type": string;
	"orders.rate_unit_desc": string;
	"orders.rate_units": number;
	"orders.ready_to_bill": string;
	"orders.recurring_order_id": string;
	"orders.reply_transmitted": string;
	"orders.requesting_company": string;
	"orders.return_temp": number;
	"orders.return_temp_dt": Date;
	"orders.return_temp_um": string;
	"orders.return_temp_var": number;
	"orders.return_temp_var_um": string;
	"orders.revenue_code_id": string;
	"orders.revenue_share_method": string;
	"orders.round_trip": string;
	"orders.sail_date": Date;
	"orders.seal_number": string;
	"orders.seg_alloc_code": string;
	"orders.setpoint_temp": number;
	"orders.setpoint_temp_um": string;
	"orders.setpoint_var": number;
	"orders.setpoint_var_um": string;
	"orders.ship_status_to_edi": string;
	"orders.shipment_id": string;
	"orders.shipper_stop_id": string;
	"orders.shipstatus2edi_dt": Date;
	"orders.ss_location_id": string;
	"orders.status": string;
	"orders.subject_order_number": string;
	"orders.subject_order_status": string;
	"orders.subject_order_void_date": Date;
	"orders.swap": string;
	"orders.teams_required": string;
	"orders.temperature_max": number;
	"orders.temperature_max_um": string;
	"orders.temperature_min": number;
	"orders.temperature_min_um": string;
	"orders.temperature_um": string;
	"orders.total_charge": number;
	"orders.total_charge_c": string;
	"orders.total_charge_d": Date;
	"orders.total_charge_n": number;
	"orders.total_charge_r": number;
	"orders.totalcharge_and_excisetax": number;
	"orders.totalcharge_and_excisetax_c": string;
	"orders.totalcharge_and_excisetax_d": Date;
	"orders.totalcharge_and_excisetax_n": number;
	"orders.totalcharge_and_excisetax_r": number;
	"orders.tractor_type": string;
	"orders.vessel": string;
	"orders.vessel_cutoff_date": Date;
	"orders.voided_load_transmitted": string;
	"orders.voided_load_transmitted_dt": Date;
	"orders.weight": number;
	"orders.weight_um": string;
	"orders.xferred2billing": string;
	"orders.xferred2billing_dt": Date;
	override_payee_id: string;
	"payee.ach_batch_class_code": string;
	"payee.add_fed_to_wh": number;
	"payee.add_fed_to_wh_c": string;
	"payee.add_fed_to_wh_d": Date;
	"payee.add_fed_to_wh_n": number;
	"payee.add_fed_to_wh_r": number;
	"payee.addl_st_to_whold": number;
	"payee.addl_st_to_whold_c": string;
	"payee.addl_st_to_whold_d": Date;
	"payee.addl_st_to_whold_n": number;
	"payee.addl_st_to_whold_r": number;
	"payee.address1": string;
	"payee.address2": string;
	"payee.adp_co_code": string;
	"payee.adp_e_no": string;
	"payee.birth_date": Date;
	"payee.check_address": string;
	"payee.check_address2": string;
	"payee.check_city": string;
	"payee.check_city_st_zip": string;
	"payee.check_date": Date;
	"payee.check_name": string;
	"payee.check_number": string;
	"payee.check_st": string;
	"payee.check_stub_comment": string;
	"payee.check_zip": string;
	"payee.city": string;
	"payee.city_amt_to_whold": number;
	"payee.city_amt_to_whold_c": string;
	"payee.city_amt_to_whold_d": Date;
	"payee.city_amt_to_whold_n": number;
	"payee.city_amt_to_whold_r": number;
	"payee.city_exemptions": number;
	"payee.city_tax_code": string;
	"payee.company_id": string;
	"payee.country_id": string;
	"payee.county_amt_to_whold": number;
	"payee.county_amt_to_whold_c": string;
	"payee.county_amt_to_whold_d": Date;
	"payee.county_amt_to_whold_n": number;
	"payee.county_amt_to_whold_r": number;
	"payee.county_exemptions": number;
	"payee.county_tax_code": string;
	"payee.currency": string;
	"payee.dependents": number;
	"payee.dependents_c": string;
	"payee.dependents_d": Date;
	"payee.dependents_n": number;
	"payee.dependents_r": number;
	"payee.disable_payroll_taxes": string;
	"payee.eft_first_name": string;
	"payee.eft_individual": string;
	"payee.eft_last_name": string;
	"payee.eft_middle_initial": string;
	"payee.email": string;
	"payee.email_summary": string;
	"payee.enable_carrier_app": string;
	"payee.exempt_from_fed": string;
	"payee.exempt_from_state": string;
	"payee.extra_withholdings": number;
	"payee.extra_withholdings_c": string;
	"payee.extra_withholdings_d": Date;
	"payee.extra_withholdings_n": number;
	"payee.extra_withholdings_r": number;
	"payee.fed_amt_to_whold": number;
	"payee.fed_amt_to_whold_c": string;
	"payee.fed_amt_to_whold_d": Date;
	"payee.fed_amt_to_whold_n": number;
	"payee.fed_amt_to_whold_r": number;
	"payee.fed_exemptions": number;
	"payee.fed_marital_status": string;
	"payee.freeze_pay": string;
	"payee.freight_matching_override": string;
	"payee.gp_exclude": string;
	"payee.gp_exported": Date;
	"payee.hire_date": Date;
	"payee.holiday_hours_pd": number;
	"payee.id": string;
	"payee.last_raise_date": Date;
	"payee.legal_name": string;
	"payee.load_booking_eligible": string;
	"payee.loadpay_contact_phone": string;
	"payee.multiple_jobs": string;
	"payee.name": string;
	"payee.non_office_emp": string;
	"payee.office_employee": string;
	"payee.other_deductions": number;
	"payee.other_deductions_c": string;
	"payee.other_deductions_d": Date;
	"payee.other_deductions_n": number;
	"payee.other_deductions_r": number;
	"payee.other_income": number;
	"payee.other_income_c": string;
	"payee.other_income_d": Date;
	"payee.other_income_n": number;
	"payee.other_income_r": number;
	"payee.overtime_hours_pd": number;
	"payee.payment_method": string;
	"payee.phone_number": string;
	"payee.posted_check_date": Date;
	"payee.prev_code": string;
	"payee.primary_agency": string;
	"payee.regular_hours_pd": number;
	"payee.remarks": string;
	"payee.settlement_status": string;
	"payee.sick_hours_pd": number;
	"payee.social_security_no": string;
	"payee.st_amt_to_whold": number;
	"payee.st_amt_to_whold_c": string;
	"payee.st_amt_to_whold_d": Date;
	"payee.st_amt_to_whold_n": number;
	"payee.st_amt_to_whold_r": number;
	"payee.st_marital_status": string;
	"payee.state": string;
	"payee.state_exemptions": number;
	"payee.state_tax_code": string;
	"payee.status": string;
	"payee.sui_tax_code": string;
	"payee.tax_table_city_aux": number;
	"payee.tax_table_city_misc": number;
	"payee.tax_table_county_aux": number;
	"payee.tax_table_county_misc": number;
	"payee.tax_table_fit_aux": number;
	"payee.tax_table_fit_misc": number;
	"payee.tax_table_st_aux": number;
	"payee.tax_table_st_misc": number;
	"payee.tax_table_sui_aux": number;
	"payee.tax_table_sui_misc": number;
	"payee.termination_date": Date;
	"payee.vacation_hours_pd": number;
	"payee.vm_part_update": string;
	"payee.w4_status": string;
	"payee.wf_queue": number;
	"payee.ytd_holiday_hrs": number;
	"payee.ytd_overtime_hrs": number;
	"payee.ytd_reg_hrs_paid": number;
	"payee.ytd_sick_hrs_paid": number;
	"payee.ytd_vacation_hrs": number;
	"payee.zip_code": string;
	resolution: string;
	review_reqd: string;
	reviewed_by: string;
	"reviewed_by_users.acct_lock_date": Date;
	"reviewed_by_users.active_date": Date;
	"reviewed_by_users.admin_user": string;
	"reviewed_by_users.agent": string;
	"reviewed_by_users.agree_fieldmarshal": Date;
	"reviewed_by_users.agree_tailor": Date;
	"reviewed_by_users.agree_tailor_ext": Date;
	"reviewed_by_users.all_contacts": string;
	"reviewed_by_users.allow_new_devices": string;
	"reviewed_by_users.alternative_user": string;
	"reviewed_by_users.ap_division_id": string;
	"reviewed_by_users.appt_sched_id": string;
	"reviewed_by_users.auth_subject": string;
	"reviewed_by_users.auto_edit_type": string;
	"reviewed_by_users.avail_tract_path": string;
	"reviewed_by_users.avail_tract_sample": string;
	"reviewed_by_users.available": string;
	"reviewed_by_users.bridge_customer_access": string;
	"reviewed_by_users.brokerage_divider": number;
	"reviewed_by_users.brokerage_planning": string;
	"reviewed_by_users.brokerage_planning2": string;
	"reviewed_by_users.brokerage_planning3": string;
	"reviewed_by_users.brokerage_planning4": string;
	"reviewed_by_users.brokerage_planning_contnr": string;
	"reviewed_by_users.call_list_profile": string;
	"reviewed_by_users.carrier_call_list_id": string;
	"reviewed_by_users.carrier_mgr_profil": string;
	"reviewed_by_users.carrier_mgr_profil2": string;
	"reviewed_by_users.carrier_mgr_profil3": string;
	"reviewed_by_users.carrier_mgr_profil4": string;
	"reviewed_by_users.cell_phone": string;
	"reviewed_by_users.close_window": string;
	"reviewed_by_users.commission_payee_id": string;
	"reviewed_by_users.company_id": string;
	"reviewed_by_users.company_name": string;
	"reviewed_by_users.conf_cntr_template": number;
	"reviewed_by_users.conf_template": number;
	"reviewed_by_users.confirm_record": string;
	"reviewed_by_users.contact_id": string;
	"reviewed_by_users.continuous_radius": number;
	"reviewed_by_users.crm_vs_profile": string;
	"reviewed_by_users.csm_profile_id": string;
	"reviewed_by_users.csm_profile_id2": string;
	"reviewed_by_users.csm_profile_id3": string;
	"reviewed_by_users.csm_profile_id4": string;
	"reviewed_by_users.currency_reporting": string;
	"reviewed_by_users.currency_transaction": string;
	"reviewed_by_users.daily_advance_limits": string;
	"reviewed_by_users.daily_brok_profile": string;
	"reviewed_by_users.daily_snap_profile": string;
	"reviewed_by_users.date_format": string;
	"reviewed_by_users.default_search": number;
	"reviewed_by_users.default_wirecode": string;
	"reviewed_by_users.delivered_load_day": number;
	"reviewed_by_users.department_id": string;
	"reviewed_by_users.detention_profile_id": string;
	"reviewed_by_users.detention_profile_id2": string;
	"reviewed_by_users.detention_profile_id3": string;
	"reviewed_by_users.detention_profile_id4": string;
	"reviewed_by_users.disp_new_order_screen": string;
	"reviewed_by_users.distance_calc_vendor": string;
	"reviewed_by_users.dock_enable_wfmd_mode_swtch": string;
	"reviewed_by_users.dock_login_id": string;
	"reviewed_by_users.dragndrop_profile_id": string;
	"reviewed_by_users.driver_manager_profile": string;
	"reviewed_by_users.driver_manager_profile2": string;
	"reviewed_by_users.driver_manager_profile3": string;
	"reviewed_by_users.driver_manager_profile4": string;
	"reviewed_by_users.driver_manager_vendor": string;
	"reviewed_by_users.driver_managers": string;
	"reviewed_by_users.drivers_wo_manager": string;
	"reviewed_by_users.ds_cap_profile": string;
	"reviewed_by_users.ds_mv_eta_profile": string;
	"reviewed_by_users.ds_mv_eval_profile": string;
	"reviewed_by_users.dsp_override_user": string;
	"reviewed_by_users.email_address": string;
	"reviewed_by_users.email_bcc": string;
	"reviewed_by_users.email_client": string;
	"reviewed_by_users.email_host": string;
	"reviewed_by_users.email_imap_host": string;
	"reviewed_by_users.email_imap_password": string;
	"reviewed_by_users.email_imap_sent_folder": string;
	"reviewed_by_users.email_imap_ssl": string;
	"reviewed_by_users.email_imap_username": string;
	"reviewed_by_users.email_override_company": string;
	"reviewed_by_users.email_password": string;
	"reviewed_by_users.email_port": number;
	"reviewed_by_users.email_protocol": string;
	"reviewed_by_users.email_use_sent_folder": string;
	"reviewed_by_users.email_username": string;
	"reviewed_by_users.employee_type": string;
	"reviewed_by_users.enable_alerts": string;
	"reviewed_by_users.extension": string;
	"reviewed_by_users.external_password": string;
	"reviewed_by_users.external_user_id": string;
	"reviewed_by_users.failed_logins": number;
	"reviewed_by_users.fax": string;
	"reviewed_by_users.fileimport_profile": string;
	"reviewed_by_users.findnear_vendor": string;
	"reviewed_by_users.fleetmgmt_prof_id": string;
	"reviewed_by_users.fm_account_id": string;
	"reviewed_by_users.fm_can_view_metadata": string;
	"reviewed_by_users.fm_profile_id": string;
	"reviewed_by_users.fm_webhook_url": string;
	"reviewed_by_users.ftl_revenue_code_id": string;
	"reviewed_by_users.google_map_layer": string;
	"reviewed_by_users.google_map_type": string;
	"reviewed_by_users.grid_even_row_color": number;
	"reviewed_by_users.grid_insert_sort": string;
	"reviewed_by_users.grid_odd_row_color": number;
	"reviewed_by_users.id": string;
	"reviewed_by_users.img_category": string;
	"reviewed_by_users.inactive_date": Date;
	"reviewed_by_users.is_active": string;
	"reviewed_by_users.is_clearer": string;
	"reviewed_by_users.is_closer": string;
	"reviewed_by_users.is_dock_supervisor": string;
	"reviewed_by_users.is_dock_worker": string;
	"reviewed_by_users.is_email_confirmed": string;
	"reviewed_by_users.is_mcleod": string;
	"reviewed_by_users.issue_atm_cash": string;
	"reviewed_by_users.lock_status": string;
	"reviewed_by_users.log_sql": string;
	"reviewed_by_users.login_id": string;
	"reviewed_by_users.ltl_carrier_brk_status": string;
	"reviewed_by_users.ltl_mapping_vendor": string;
	"reviewed_by_users.ltl_quote_template": number;
	"reviewed_by_users.manifest_profile": string;
	"reviewed_by_users.margin_percentage": number;
	"reviewed_by_users.max_payment_code_amt": number;
	"reviewed_by_users.max_payment_code_amt_c": string;
	"reviewed_by_users.max_payment_code_amt_d": Date;
	"reviewed_by_users.max_payment_code_amt_n": number;
	"reviewed_by_users.max_payment_code_amt_r": number;
	"reviewed_by_users.mc_position_vendor": string;
	"reviewed_by_users.menu_tree_view": string;
	"reviewed_by_users.mfa_device_id": string;
	"reviewed_by_users.mfa_last_prompted": Date;
	"reviewed_by_users.mfa_secret": string;
	"reviewed_by_users.mfa_status": string;
	"reviewed_by_users.mobcomm_profile_id": string;
	"reviewed_by_users.mobile_pw_reset_token": string;
	"reviewed_by_users.mobile_pw_token_expire_ms": number;
	"reviewed_by_users.move_dates": string;
	"reviewed_by_users.movement_map_vendor": string;
	"reviewed_by_users.name": string;
	"reviewed_by_users.notification": string;
	"reviewed_by_users.notify_alerts": string;
	"reviewed_by_users.notify_frequency": string;
	"reviewed_by_users.notify_method": string;
	"reviewed_by_users.notify_occurance": string;
	"reviewed_by_users.operations_user_id": string;
	"reviewed_by_users.order_mode": string;
	"reviewed_by_users.order_planning2": string;
	"reviewed_by_users.order_planning3": string;
	"reviewed_by_users.order_planning4": string;
	"reviewed_by_users.order_planning_vendor": string;
	"reviewed_by_users.order_tran_request": string;
	"reviewed_by_users.orderhist_profile": string;
	"reviewed_by_users.outbound_notification": string;
	"reviewed_by_users.override_vendor_division": string;
	"reviewed_by_users.payee_id": string;
	"reviewed_by_users.pbw_brokerage_planning": string;
	"reviewed_by_users.phone": string;
	"reviewed_by_users.planner": string;
	"reviewed_by_users.planning": string;
	"reviewed_by_users.planning_container": string;
	"reviewed_by_users.planning_divider": number;
	"reviewed_by_users.portal_admin_id": string;
	"reviewed_by_users.primary_agency": string;
	"reviewed_by_users.prompt_cont_moves": string;
	"reviewed_by_users.quote_comp_act_create": string;
	"reviewed_by_users.quote_comp_act_id": string;
	"reviewed_by_users.quote_pend_act_create": string;
	"reviewed_by_users.quote_pend_act_id": string;
	"reviewed_by_users.quote_template": number;
	"reviewed_by_users.rapid_alert_expand": string;
	"reviewed_by_users.rapid_alert_sound": string;
	"reviewed_by_users.receive_alerts": string;
	"reviewed_by_users.recruiting_profile": string;
	"reviewed_by_users.request_location_vendor": string;
	"reviewed_by_users.revenue_code_id": string;
	"reviewed_by_users.route_detail_vendor": string;
	"reviewed_by_users.save_screen_sizes": string;
	"reviewed_by_users.search_history_limit": number;
	"reviewed_by_users.sec_ans1": string;
	"reviewed_by_users.sec_ans2": string;
	"reviewed_by_users.sec_question1": number;
	"reviewed_by_users.sec_question2": number;
	"reviewed_by_users.seg_alloc_code": string;
	"reviewed_by_users.sel_text_on_focus": string;
	"reviewed_by_users.show_active": string;
	"reviewed_by_users.show_google_route": string;
	"reviewed_by_users.show_inactive": string;
	"reviewed_by_users.single_point_vendor": string;
	"reviewed_by_users.support_inactivate_date": Date;
	"reviewed_by_users.system_tray": string;
	"reviewed_by_users.table_even_row_color": string;
	"reviewed_by_users.table_odd_row_color": string;
	"reviewed_by_users.telephony_access_token": string;
	"reviewed_by_users.telephony_access_token_exp": Date;
	"reviewed_by_users.telephony_number": string;
	"reviewed_by_users.telephony_password": string;
	"reviewed_by_users.telephony_refresh_token": string;
	"reviewed_by_users.telephony_refresh_token_exp": Date;
	"reviewed_by_users.terminal_id": string;
	"reviewed_by_users.time_format": string;
	"reviewed_by_users.token_key": number;
	"reviewed_by_users.toolbar_multi_rows": string;
	"reviewed_by_users.toolbar_setting": string;
	"reviewed_by_users.trailer_loan_profile_id": string;
	"reviewed_by_users.trailer_wash_loc": string;
	"reviewed_by_users.trailer_wash_user": string;
	"reviewed_by_users.trimble_map_traffic": string;
	"reviewed_by_users.tw_seg_code": string;
	"reviewed_by_users.tw_ticket_template": number;
	"reviewed_by_users.type_agents": string;
	"reviewed_by_users.type_carrier": string;
	"reviewed_by_users.type_company_drs": string;
	"reviewed_by_users.type_number": string;
	"reviewed_by_users.type_owner_oper": string;
	"reviewed_by_users.user_group": string;
	"reviewed_by_users.vendor_user_id": string;
	"reviewed_by_users.view_movement_vendor": string;
	"reviewed_by_users.waterfall_default_rt_guide": string;
	"reviewed_by_users.waterfall_include_rates": string;
	"reviewed_by_users.waterfall_include_rt_guides": string;
	"reviewed_by_users.waterfall_prevent_tendering": string;
	"reviewed_by_users.web_acct_status": string;
	"reviewed_by_users.web_agent": string;
	"reviewed_by_users.web_created_on": Date;
	"reviewed_by_users.web_enabled_on": Date;
	"reviewed_by_users.web_last_login": Date;
	"reviewed_by_users.web_locked_on": Date;
	"reviewed_by_users.web_map": string;
	"reviewed_by_users.web_password": string;
	"reviewed_by_users.web_user_id": string;
	"reviewed_by_users.web_user_type": string;
	"reviewed_by_users.window_location": string;
	"reviewed_by_users.windows_login": string;
	"reviewed_by_users.wire_trans_per_day": number;
	"reviewed_by_users.zone_mapping_vendor": string;
	reviewed_date: Date;
	sched_arrive_early: Date;
	sched_arrive_late: Date;
	status: string;
	stop_id: string;
	stop_no: number;
	stop_type: string;
	"terminal.address1": string;
	"terminal.address2": string;
	"terminal.appt_required": string;
	"terminal.assigned_to": string;
	"terminal.bseg": string;
	"terminal.category": string;
	"terminal.cbsa_port_id": string;
	"terminal.chassis_owner": string;
	"terminal.chassis_pool": string;
	"terminal.city_id": number;
	"terminal.city_name": string;
	"terminal.class_rqmt": string;
	"terminal.comments": string;
	"terminal.company_id": string;
	"terminal.container_pool": string;
	"terminal.container_vendor": string;
	"terminal.cust_id": string;
	"terminal.customer_id": string;
	"terminal.days_between_calls": number;
	"terminal.ded_rqmt_type": string;
	"terminal.ded_type": string;
	"terminal.def_commodity_desc": string;
	"terminal.def_commodity_id": string;
	"terminal.delivery_date_option": string;
	"terminal.directions": string;
	"terminal.disable_loc_rating": string;
	"terminal.dl_gen_cost": number;
	"terminal.dl_gen_repower": number;
	"terminal.dl_haz_cost": number;
	"terminal.dl_haz_repower": number;
	"terminal.dl_hvl_cost": number;
	"terminal.dl_hvl_repower": number;
	"terminal.dl_load_time": number;
	"terminal.dl_svc_cost": number;
	"terminal.dl_svc_repower": number;
	"terminal.dl_unload_time": number;
	"terminal.driver_load_id": string;
	"terminal.driver_unload_id": string;
	"terminal.ds_capacity_cost": number;
	"terminal.ds_model_flag": string;
	"terminal.extra_handling_time": number;
	"terminal.filer_code": string;
	"terminal.foreign_port": string;
	"terminal.friday_close": Date;
	"terminal.friday_open": Date;
	"terminal.fuel_price_region": string;
	"terminal.google_place_fm_address": string;
	"terminal.google_place_id": string;
	"terminal.google_place_type": string;
	"terminal.id": string;
	"terminal.include_xref_trailers": string;
	"terminal.insur_amt_rqrd": number;
	"terminal.insur_amt_rqrd_c": string;
	"terminal.insur_amt_rqrd_d": Date;
	"terminal.insur_amt_rqrd_n": number;
	"terminal.insur_amt_rqrd_r": number;
	"terminal.is_active": string;
	"terminal.is_consignee": string;
	"terminal.is_customer": string;
	"terminal.is_customs_broker": string;
	"terminal.is_dist_center": string;
	"terminal.is_dl_gen": string;
	"terminal.is_dl_haz": string;
	"terminal.is_dl_hvl": string;
	"terminal.is_dl_svc": string;
	"terminal.is_drop_yard": string;
	"terminal.is_geocoded": string;
	"terminal.is_outside_terminal": string;
	"terminal.is_prospect": string;
	"terminal.is_remote_terminal": string;
	"terminal.is_shipper": string;
	"terminal.is_steamship": string;
	"terminal.is_terminal": string;
	"terminal.is_trailer_pool": string;
	"terminal.is_trailer_wash": string;
	"terminal.is_truckstop": string;
	"terminal.last_used_date": Date;
	"terminal.latitude": number;
	"terminal.layover": string;
	"terminal.load_unload_count": number;
	"terminal.load_unload_excl": string;
	"terminal.load_unload_param": string;
	"terminal.loading_instructs": string;
	"terminal.loading_time": number;
	"terminal.longitude": number;
	"terminal.ltl_optimize_time_per_spot": number;
	"terminal.ltl_seg_alloc_code": string;
	"terminal.manual_exchange": string;
	"terminal.max_drvr_complaint": number;
	"terminal.max_pallet_balance": number;
	"terminal.max_payment_code_amt": number;
	"terminal.max_payment_code_amt_c": string;
	"terminal.max_payment_code_amt_d": Date;
	"terminal.max_payment_code_amt_n": number;
	"terminal.max_payment_code_amt_r": number;
	"terminal.model_flag": string;
	"terminal.monday_close": Date;
	"terminal.monday_open": Date;
	"terminal.name": string;
	"terminal.need_clean_trailer": string;
	"terminal.next_call_date": Date;
	"terminal.no_fuel_radius_inbound": string;
	"terminal.no_fuel_radius_outbound": number;
	"terminal.no_stop_miles": number;
	"terminal.on_duty_not_driving_mins": number;
	"terminal.pallet_balance": number;
	"terminal.pallets_required": string;
	"terminal.payment_api_excluded": string;
	"terminal.pickup_date_option": string;
	"terminal.plc_uid": number;
	"terminal.pnn_city_id": number;
	"terminal.pnn_city_name": string;
	"terminal.pnn_state": string;
	"terminal.pnn_zip_code": string;
	"terminal.port_id": string;
	"terminal.prev_code": string;
	"terminal.primary_agency": string;
	"terminal.radius": number;
	"terminal.regulated": string;
	"terminal.reload_rqmt": string;
	"terminal.reserve_mins": number;
	"terminal.salesperson": string;
	"terminal.saturday_close": Date;
	"terminal.saturday_open": Date;
	"terminal.shuttle_capacity": string;
	"terminal.state": string;
	"terminal.sunday_close": Date;
	"terminal.sunday_open": Date;
	"terminal.swap_cost": number;
	"terminal.team_rqmt": string;
	"terminal.thursday_close": Date;
	"terminal.thursday_open": Date;
	"terminal.trailer_pool_min": number;
	"terminal.trailer_pool_radius": number;
	"terminal.trailer_pool_size": number;
	"terminal.trailer_wash_vend": string;
	"terminal.trimble_place_id": string;
	"terminal.trip_starter": string;
	"terminal.tuesday_close": Date;
	"terminal.tuesday_open": Date;
	"terminal.tw_seg_code": string;
	"terminal.unload_instructs": string;
	"terminal.unloading_time": number;
	"terminal.website_url": string;
	"terminal.wednesday_close": Date;
	"terminal.wednesday_open": Date;
	"terminal.zip_code": string;
	terminal_id: string;
	tractor_id: string;
	trailer_id: string;
	user_id: string;
}

